(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("newsEntry", [], factory);
	else if(typeof exports === 'object')
		exports["newsEntry"] = factory();
	else
		root["newsEntry"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 204);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(32)('wks');
var uid = __webpack_require__(29);
var Symbol = __webpack_require__(1).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var ctx = __webpack_require__(9);
var hide = __webpack_require__(7);
var has = __webpack_require__(10);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var createDesc = __webpack_require__(17);
module.exports = __webpack_require__(3) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(42);
var toPrimitive = __webpack_require__(38);
var dP = Object.defineProperty;

exports.f = __webpack_require__(3) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(13);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(44);
var defined = __webpack_require__(20);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var document = __webpack_require__(1).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(8).f;
var has = __webpack_require__(10);
var TAG = __webpack_require__(2)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(32)('keys');
var uid = __webpack_require__(29);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(54);
var enumBugKeys = __webpack_require__(33);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(20);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDFPBlock;
function getDFPBlock(slotId, slotSize, advPlace, advPlaceWidth, callback, fallback) {
    var advWrapper = document.getElementById(advPlace);
    /* let adlCont = advWrapper.getAttribute('adlcont') === 'false' ? '' : 'adult24';*/

    advWrapper.style.margin = '0 auto';
    if (typeof advPlaceWidth != 'undefined') {
        advWrapper.style.width = advPlaceWidth;
    }

    if (typeof googletag === 'undefined') {
        window.googletag = window.googletag || {};
        window.googletag.cmd = window.googletag.cmd || [];
        var gads = document.createElement('script');
        gads.async = true;
        gads.type = 'text/javascript';
        gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
        var node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(gads, node);
    }

    googletag.cmd.push(function () {
        var slot = googletag.defineSlot(slotId, slotSize, advPlace).addService(googletag.pubads())
        // .setTargeting('ContType', adlCont)
        .setTargeting('siteName', dfpTargetingInfinite.siteName);

        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.display(slot);

        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
            if (slot === event.slot) {
                if (!event.isEmpty) {
                    if (typeof callback !== 'undefined') {
                        callback(event);
                    }
                } else if (typeof fallback !== 'undefined') {
                    getDFPBlock(fallback.id, fallback.size, fallback.wrapper);
                    fallback = undefined;
                } else {

                    //get native adv name from advPlace:  adv1454411100_left, adv1454411100_right
                    if (advPlace.includes('_')) {
                        document.getElementById(advPlace.substring(0, advPlace.indexOf('_'))).style.display = 'none';
                    }

                    advWrapper.style.display = 'none';
                }
            }
        });
    });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(21);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(70)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(34)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// core
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(116),
      __webpack_require__(41),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( EvEmitter, utils) {
      return factory( window, EvEmitter, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, EvEmitter, utils ) {

var jQuery = window.jQuery;
// internal store of all InfiniteScroll intances
var instances = {};

function InfiniteScroll( element, options ) {
  var queryElem = utils.getQueryElement( element );

  if ( !queryElem ) {
    console.error( 'Bad element for InfiniteScroll: ' + ( queryElem || element ) );
    return;
  }
  element = queryElem;
  // do not initialize twice on same element
  if ( element.infiniteScrollGUID ) {
    var instance = instances[ element.infiniteScrollGUID ];
    instance.option( options );
    return instance;
  }

  this.element = element;
  // options
  this.options = utils.extend( {}, InfiniteScroll.defaults );
  this.option( options );
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  this.create();
}

// defaults
InfiniteScroll.defaults = {
  // path: null,
  // hideNav: null,
  // debug: false,
};

// create & destroy methods
InfiniteScroll.create = {};
InfiniteScroll.destroy = {};

var proto = InfiniteScroll.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

// --------------------------  -------------------------- //

// globally unique identifiers
var GUID = 0;

proto.create = function() {
  // create core
  // add id for InfiniteScroll.data
  var id = this.guid = ++GUID;
  this.element.infiniteScrollGUID = id; // expando
  instances[ id ] = this; // associate via id
  // properties
  this.pageIndex = 1; // default to first page
  this.loadCount = 0;
  this.updateGetPath();
  // bail if getPath not set, or returns falsey #776
  var hasPath = this.getPath && this.getPath();
  if ( !hasPath ) {
    console.error('Disabling InfiniteScroll');
    return;
  }
  this.updateGetAbsolutePath();
  this.log( 'initialized', [ this.element.className ] );
  this.callOnInit();
  // create features
  for ( var method in InfiniteScroll.create ) {
    InfiniteScroll.create[ method ].call( this );
  }
};

proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

// call onInit option, used for binding events on init
proto.callOnInit = function() {
  var onInit = this.options.onInit;
  if ( onInit ) {
    onInit.call( this, this );
  }
};

// ----- events ----- //

proto.dispatchEvent = function( type, event, args ) {
  this.log( type, args );
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );
  // trigger jQuery event
  if ( !jQuery || !this.$element ) {
    return;
  }
  // namespace jQuery event
  type += '.infiniteScroll';
  var $event = type;
  if ( event ) {
    // create jQuery event
    var jQEvent = jQuery.Event( event );
    jQEvent.type = type;
    $event = jQEvent;
  }
  this.$element.trigger( $event, args );
};

var loggers = {
  initialized: function( className ) {
    return 'on ' + className;
  },
  request: function( path ) {
    return 'URL: ' + path;
  },
  load: function( response, path ) {
    return ( response.title || '' ) + '. URL: ' + path;
  },
  error: function( error, path ) {
    return error + '. URL: ' + path;
  },
  append: function( response, path, items ) {
    return items.length + ' items. URL: ' + path;
  },
  last: function( response, path ) {
    return 'URL: ' + path;
  },
  history: function( title, path ) {
    return 'URL: ' + path;
  },
  pageIndex: function( index, origin ) {
    return 'current page determined to be: ' + index + ' from ' + origin;
  },
};

// log events
proto.log = function( type, args ) {
  if ( !this.options.debug ) {
    return;
  }
  var message = '[InfiniteScroll] ' + type;
  var logger = loggers[ type ];
  if ( logger ) {
    message += '. ' + logger.apply( this, args );
  }
  console.log( message );
};

// -------------------------- methods used amoung features -------------------------- //

proto.updateMeasurements = function() {
  this.windowHeight = window.innerHeight;
  var rect = this.element.getBoundingClientRect();
  this.top = rect.top + window.pageYOffset;
};

proto.updateScroller = function() {
  var elementScroll = this.options.elementScroll;
  if ( !elementScroll ) {
    // default, use window
    this.scroller = window;
    return;
  }
  // if true, set to element, otherwise use option
  this.scroller = elementScroll === true ? this.element :
    utils.getQueryElement( elementScroll );
  if ( !this.scroller ) {
    throw 'Unable to find elementScroll: ' + elementScroll;
  }
};

// -------------------------- page path -------------------------- //

proto.updateGetPath = function() {
  var optPath = this.options.path;
  if ( !optPath ) {
    console.error( 'InfiniteScroll path option required. Set as: ' + optPath );
    return;
  }
  // function
  var type = typeof optPath;
  if ( type == 'function' ) {
    this.getPath = optPath;
    return;
  }
  // template string: '/pages/{{#}}.html'
  var templateMatch = type == 'string' && optPath.match('{{#}}');
  if ( templateMatch ) {
    this.updateGetPathTemplate( optPath );
    return;
  }
  // selector: '.next-page-selector'
  this.updateGetPathSelector( optPath );
};

proto.updateGetPathTemplate = function( optPath ) {
  // set getPath with template string
  this.getPath = function() {
    var nextIndex = this.pageIndex + 1;
    return optPath.replace( '{{#}}', nextIndex );
  }.bind( this );
  // get pageIndex from location
  // convert path option into regex to look for pattern in location
  // escape query (?) in url, allows for parsing GET parameters 
  var regexString = optPath
    .replace( /(\\\?|\?)/, '\\?' )
    .replace( '{{#}}', '(\\d\\d?\\d?)' );
  var templateRe = new RegExp( regexString );
  var match = location.href.match( templateRe );

  if ( match ) {
    this.pageIndex = parseInt( match[1], 10 );
    this.log( 'pageIndex', [ this.pageIndex, 'template string' ] );
  }
};

var pathRegexes = [
  // WordPress & Tumblr - example.com/page/2
  // Jekyll - example.com/page2
  /^(.*?\/?page\/?)(\d\d?\d?)(.*?$)/,
  // Drupal - example.com/?page=1
  /^(.*?\/?\?page=)(\d\d?\d?)(.*?$)/,
  // catch all, last occurence of a number
  /(.*?)(\d\d?\d?)(?!.*\d)(.*?$)/,
];

proto.updateGetPathSelector = function( optPath ) {
  // parse href of link: '.next-page-link'
  var hrefElem = document.querySelector( optPath );
  if ( !hrefElem ) {
    console.error( 'Bad InfiniteScroll path option. Next link not found: ' +
      optPath );
    return;
  }
  var href = hrefElem.getAttribute('href');
  // try matching href to pathRegexes patterns
  var pathParts, regex;
  for ( var i=0; href && i < pathRegexes.length; i++ ) {
    regex = pathRegexes[i];
    var match = href.match( regex );
    if ( match ) {
      pathParts = match.slice(1); // remove first part
      break;
    }
  }
  if ( !pathParts ) {
    console.error( 'InfiniteScroll unable to parse next link href: ' + href );
    return;
  }
  this.isPathSelector = true; // flag for checkLastPage()
  this.getPath = function() {
    var nextIndex = this.pageIndex + 1;
    return pathParts[0] + nextIndex + pathParts[2];
  }.bind( this );
  // get pageIndex from href
  this.pageIndex = parseInt( pathParts[1], 10 ) - 1;
  this.log( 'pageIndex', [ this.pageIndex, 'next link' ] );
};

proto.updateGetAbsolutePath = function() {
  var path = this.getPath();
  // path doesn't start with http or /
  var isAbsolute = path.match( /^http/ ) || path.match( /^\// );
  if ( isAbsolute ) {
    this.getAbsolutePath = this.getPath;
    return;
  }

  var pathname = location.pathname;
  // query parameter #829. example.com/?pg=2
  var isQuery = path.match( /^\?/ );
  if ( isQuery ) {
    this.getAbsolutePath = function() {
      return pathname + this.getPath();
    };
    return;
  }

  // /foo/bar/index.html => /foo/bar
  var directory = pathname.substring( 0, pathname.lastIndexOf('/') );
  this.getAbsolutePath = function() {
    return directory + '/' + this.getPath();
  };
};

// -------------------------- nav -------------------------- //

// hide navigation
InfiniteScroll.create.hideNav = function() {
  var nav = utils.getQueryElement( this.options.hideNav );
  if ( !nav ) {
    return;
  }
  nav.style.display = 'none';
  this.nav = nav;
};

InfiniteScroll.destroy.hideNav = function() {
  if ( this.nav ) {
    this.nav.style.display = '';
  }
};

// -------------------------- destroy -------------------------- //

proto.destroy = function() {
  this.allOff(); // remove all event listeners
  // call destroy methods
  for ( var method in InfiniteScroll.destroy ) {
    InfiniteScroll.destroy[ method ].call( this );
  }

  delete this.element.infiniteScrollGUID;
  delete instances[ this.guid ];
  // remove jQuery data. #807
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'infiniteScroll' );
  }
};

// -------------------------- utilities -------------------------- //

// https://remysharp.com/2010/07/21/throttling-function-calls
InfiniteScroll.throttle = function( fn, threshold ) {
  threshold = threshold || 200;
  var last, timeout;

  return function() {
    var now = +new Date();
    var args = arguments;
    var trigger = function() {
      last = now;
      fn.apply( this, args );
    }.bind( this );
    if ( last && now < last + threshold ) {
      // hold on to it
      clearTimeout( timeout );
      timeout = setTimeout( trigger, threshold );
    } else {
      trigger();
    }
  };
};

InfiniteScroll.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.infiniteScrollGUID;
  return id && instances[ id ];
};

// set internal jQuery, for Webpack + jQuery v3
InfiniteScroll.setJQuery = function( $ ) {
  jQuery = $;
};

// -------------------------- setup -------------------------- //

utils.htmlInit( InfiniteScroll, 'infinite-scroll' );

// add noop _init method for jQuery Bridget. #768
proto._init = function() {};

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'infiniteScroll', InfiniteScroll );
}

// --------------------------  -------------------------- //

return InfiniteScroll;

}));


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(13);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (element, action) {
    var device = '';
    if (window.innerWidth < 640) {
        device = 'Mobile: ';
    } else {
        device = 'Desktop: ';
    }

    var event = 'Track Element ' + device + element;
    if (typeof _paq !== 'undefined') {
        _paq.push(['trackEvent', event, action]);
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(1);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(18) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 33 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(18);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(56);
var hide = __webpack_require__(7);
var Iterators = __webpack_require__(11);
var $iterCreate = __webpack_require__(68);
var setToStringTag = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(69);
var ITERATOR = __webpack_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(15);
var TAG = __webpack_require__(2)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(61);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
var global = __webpack_require__(1);
var hide = __webpack_require__(7);
var Iterators = __webpack_require__(11);
var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(35);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(11);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(117)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( matchesSelector ) {
      return factory( window, matchesSelector );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(3) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(16)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(1).document;
module.exports = document && document.documentElement;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(15);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(57);
var enumBugKeys = __webpack_require__(33);
var IE_PROTO = __webpack_require__(22)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(16)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(43).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(13);
var SPECIES = __webpack_require__(2)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(9);
var invoke = __webpack_require__(83);
var html = __webpack_require__(43);
var cel = __webpack_require__(16);
var global = __webpack_require__(1);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(15)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(30);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(95), __esModule: true };

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(9);
var call = __webpack_require__(58);
var isArrayIter = __webpack_require__(59);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(26);
var getIterFn = __webpack_require__(40);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (url) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';

    head.appendChild(script);

    return script;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIObject = __webpack_require__(14);
var arrayIndexOf = __webpack_require__(64)(false);
var IE_PROTO = __webpack_require__(22)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(23);

module.exports = __webpack_require__(3) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(11);
var ITERATOR = __webpack_require__(2)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(2)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(62), __esModule: true };

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(3), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(14);
var toLength = __webpack_require__(26);
var toAbsoluteIndex = __webpack_require__(65);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(67);
var step = __webpack_require__(55);
var Iterators = __webpack_require__(11);
var toIObject = __webpack_require__(14);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(34)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(45);
var descriptor = __webpack_require__(17);
var setToStringTag = __webpack_require__(19);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(7)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(10);
var toObject = __webpack_require__(24);
var IE_PROTO = __webpack_require__(22)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21);
var defined = __webpack_require__(20);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(80);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {



/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(7);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (selector, func) {
    var target = document.querySelectorAll(selector);
    var lastTarget = target[target.length - 1];

    if (lastTarget !== null) {
        var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                func();
                io.unobserve(lastTarget);
            }
        }, {});
        io.observe(lastTarget);
    }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    window.loadingMedia = undefined;
    (0, _destroyAdv2.default)(['adpartner-media-95', 'adpartner-media-3913', 'adpartner_95', 'adpartner_3913', 'catfish-desktop-', 'desktop-catfish-close-button', 'adpartner-jsunit-']);
};

var _destroyAdv = __webpack_require__(93);

var _destroyAdv2 = _interopRequireDefault(_destroyAdv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var dP = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(3);
var SPECIES = __webpack_require__(2)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detectOs = {
    getUserAgent: function getUserAgent() {
        return navigator.userAgent;
    },
    getPlatform: function getPlatform() {
        return navigator.platform;
    },
    isIos: function isIos() {
        return (/iPhone|iPad|iPod/.test(detectOs.getPlatform())
        );
    },
    isAndroid: function isAndroid() {
        return (/Android/.test(detectOs.getUserAgent())
        );
    },
    isBlackBerry: function isBlackBerry() {
        return (/BlackBerry/.test(detectOs.getPlatform())
        );
    },
    isMac: function isMac() {
        return (/Mac/.test(detectOs.getPlatform())
        );
    },
    isWindows: function isWindows() {
        return (/Win/.test(detectOs.getUserAgent())
        );
    },
    isLinux: function isLinux() {
        return (/Linux/.test(detectOs.getPlatform()) && !detectOs.isAndroid()
        );
    },
    get: function get() {
        if (detectOs.isIos()) return 'iOS';
        if (detectOs.isAndroid()) return 'Android';
        if (detectOs.isBlackBerry()) return 'BlackBerry';
        if (detectOs.isMac()) return 'Mac';
        if (detectOs.isWindows()) return 'Windows';
        if (detectOs.isLinux()) return 'Linux';
        return 'Unknown';
    },
    isMobile: function isMobile() {
        return detectOs.isIos() || detectOs.isAndroid();
    }
};

module.exports = detectOs;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(81), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
__webpack_require__(27);
__webpack_require__(39);
__webpack_require__(82);
__webpack_require__(86);
__webpack_require__(87);
module.exports = __webpack_require__(0).Promise;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(18);
var global = __webpack_require__(1);
var ctx = __webpack_require__(9);
var classof = __webpack_require__(35);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(6);
var aFunction = __webpack_require__(13);
var anInstance = __webpack_require__(74);
var forOf = __webpack_require__(52);
var speciesConstructor = __webpack_require__(46);
var task = __webpack_require__(47).set;
var microtask = __webpack_require__(84)();
var newPromiseCapabilityModule = __webpack_require__(30);
var perform = __webpack_require__(48);
var userAgent = __webpack_require__(85);
var promiseResolve = __webpack_require__(49);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(2)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(75)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(19)($Promise, PROMISE);
__webpack_require__(78)(PROMISE);
Wrapper = __webpack_require__(0)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(60)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var macrotask = __webpack_require__(47).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(15)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var global = __webpack_require__(1);
var speciesConstructor = __webpack_require__(46);
var promiseResolve = __webpack_require__(49);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(30);
var perform = __webpack_require__(48);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt) {
    if (document.getElementById('newsAnnotation') === null) {
        return;
    }

    (0, _createIntersectionObserver2.default)('#newsAnnotation', renderCatFish);

    function renderCatFish() {
        var mobileCatfishPlace = document.getElementById('mobile-banner-zone');
        if (mobileCatfishPlace !== null) {

            (0, _destroyCatfish2.default)();
            (0, _sendToPiwik2.default)('render catfish start');

            var catfishId = 'catfish-desktop-' + Math.round(Math.random() * 1000000);
            var catfishWrapper = document.createElement('div');
            catfishWrapper.id = catfishId;
            mobileCatfishPlace.after(catfishWrapper);

            if (window.innerWidth < 640) {
                var siteId = opt.subsiteName === 'lifestyle' ? 1065 : 4;
                var unitId = opt.subsiteName === 'lifestyle' ? 3913 : 95;

                (0, _loadScript2.default)('https://a4p.adpartner.pro/media?site_id=' + siteId + '&unit_id=' + unitId);
            } else if (window.innerWidth >= 1024) {
                var computeDesktopCatfish = (0, _styleCatfish2.default)('catfish-desktop-', 970);

                (0, _getDFPBlock2.default)('/56301415/24tv_desktop_catfish', [[970, 90], [1, 1]], catfishId, '970px', computeDesktopCatfish, undefined);
            }
        }
    }
};

var _createIntersectionObserver = __webpack_require__(76);

var _createIntersectionObserver2 = _interopRequireDefault(_createIntersectionObserver);

var _sendToPiwik = __webpack_require__(31);

var _sendToPiwik2 = _interopRequireDefault(_sendToPiwik);

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

var _destroyCatfish = __webpack_require__(77);

var _destroyCatfish2 = _interopRequireDefault(_destroyCatfish);

var _loadScript = __webpack_require__(53);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _styleCatfish = __webpack_require__(103);

var _styleCatfish2 = _interopRequireDefault(_styleCatfish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 91 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var adCore = function () {
    var pub = {};

    /**
     * DFP TOOLS
     * */
    function initDfp() {
        window.googletag = window.googletag || {};
        window.googletag.cmd = window.googletag.cmd || [];

        if (window.googletag.cmd.length === 0) {
            var gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';
            gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
            var node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);
        }
    }

    pub.defineDfpSlot = function (params) {
        initDfp();

        //check is DFP core initialized
        if (!window.hasOwnProperty('googletag')) {
            console.warn('DFP core is not initialized!');
            return false;
        }

        var googletag = window.googletag,
            slot = void 0;

        //create DFP slot
        googletag.cmd.push(function () {
            slot = googletag.defineSlot(params.name, params.sizes, params.id);

            for (var i = 0; i < params.targeting.length; i++) {
                if (params.targeting[i] !== null && params.targeting[i][0] !== null && params.targeting[i][1] !== null) {
                    slot.setTargeting(params.targeting[i][0], params.targeting[i][1]);
                }
            }

            slot.addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();

            if (params.hasOwnProperty('callback') && typeof params.callback === 'function') {

                googletag.pubads().addEventListener('slotRenderEnded', function (e) {
                    //mobileAdSlot && event.slot === mobileAdSlot && !event.isEmpty
                    if (e.slot === slot) {
                        params.callback(e);
                    }
                });
            }

            googletag.enableServices();
        });
        return slot;
    };

    /**
     * RESPONSIVE TOOLS
     * */
    pub.isLargerThan = function (size) {
        return window.matchMedia && window.matchMedia("(min-width: " + size + "px)").matches ? true : false;
    };

    pub.isSmallerThan = function (size) {
        return !pub.isLargerThan(size);
    };

    /**
     * GET PAGE NAME
     * */
    pub.getPageName = function () {
        /* obId matcher */
        var newsIdMatcher = document.location.href.match(/(_n|objectId=|tagId=)(\d+)/i) || [];
        if (newsIdMatcher && newsIdMatcher.length >= 3) {
            if (typeof newsIdMatcher[2] === 'string') {
                return newsIdMatcher[2];
            }
        }

        if (document.location.pathname === '/' || document.location.pathname === '/football24/' || document.location.pathname === '/ru/') {
            return "main";
        }

        if (document.location.href.match(/forecast_score|game_gid|showGame.do|showForecastScore.do|forecast_/gi)) {
            return "forecast";
        }

        if (document.location.href.match(/\/home\//)) {
            return document.location.pathname;
        }

        return "site";
    };

    pub.isMobile = function () {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        );
    };

    /**
     * UTILS
     * */
    pub.throttle = function throttle(fn, wait) {
        var time = Date.now();
        return function () {
            if (time + wait - Date.now() < 0) {
                fn();
                time = Date.now();
            }
        };
    };

    return pub;
}();

/**
 * TARGETING
 * */
adCore.targeting = function () {
    var targeting = [];

    return {
        set: function set(key, value) {
            targeting.push([key, value]);
        },

        getAll: function getAll() {
            return targeting;
        }
    };
}();

module.exports = adCore;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(51);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function (wrappers) {
    wrappers.forEach(function (wrapper) {
        var advWrapper = document.querySelectorAll('[id^=' + wrapper + ']');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(advWrapper), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var element = _step.value;

                element.remove();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (func, selector, shift) {
    if (selector && 'IntersectionObserver' in window) {
        var rootMargin = shift ? shift : '480px';
        var target = document.getElementById(selector);
        var io = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                func();
                io.unobserve(target);
            }
        }, {
            rootMargin: rootMargin
        });
        io.observe(target);
    } else {
        window.addEventListener('load', function () {
            setTimeout(func, 2500);
        });
    }
};

;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(39);
__webpack_require__(27);
module.exports = __webpack_require__(96);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var get = __webpack_require__(40);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(98);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt) {
    var timeout = opt.timeout ? opt.timeout : 500;
    var waitTime = opt.waitTime ? opt.waitTime : 0;
    var scrollDepth = opt.scrollDepth ? opt.scrollDepth : 0;
    var func = opt.func;
    var loadStarted = false;

    window.addEventListener('scroll', debouncer);

    function debouncer() {
        (0, _debounce.debounce)(function (scrollEvent) {
            if (loadStarted || window.pageYOffset < scrollDepth) return false;
            loadStarted = true;
            setTimeout(function () {
                func();
            }, timeout);
        }, waitTime)();
    }
};

var _debounce = __webpack_require__(88);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (url) {
    var head = document.getElementsByTagName('head')[0];
    var style = document.createElement('link');
    style.href = url;
    style.rel = 'stylesheet';
    style.type = 'text/css';

    head.appendChild(style);

    return style;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(36);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(37);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewCounter = function () {

    /**
     * Creates an instance of view count element
     * and fills counter
     *
     * @param {opt} opt configuration object.
     * @example { selector: '#counter', entityKey: '3848382', apiDns: 'https://counter24.luxnet.ua/'}
     * */
    function ViewCounter(opt) {
        (0, _classCallCheck3.default)(this, ViewCounter);

        var elem = document.querySelector(opt.selector);

        if (!(elem && opt.entityKey && opt.apiDns)) {
            console.info('ViewCounter initialization error. Wrong configuration.');
            return;
        }

        this.elem = elem;
        this.entityKey = opt.entityKey;
        this.apiDns = opt.apiDns;

        /* Initialize the widget */
        this._init();
    }

    (0, _createClass3.default)(ViewCounter, [{
        key: '_init',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.requestViewCount(this.entityKey);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _init() {
                return _ref.apply(this, arguments);
            }

            return _init;
        }()

        /**
         * Method increases or creates new counter with key
         * @see https://counter24.luxnet.ua/api-doc/
         * */

    }, {
        key: 'requestViewCount',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var res, data;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return fetch(this.apiDns + 'counter/' + this.entityKey, {
                                    method: 'POST'
                                });

                            case 3:
                                res = _context2.sent;
                                _context2.next = 6;
                                return res.json();

                            case 6:
                                data = _context2.sent;

                                this.elem.innerHTML = data.value ? data.value : 0;
                                _context2.next = 14;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](0);

                                console.error('Failed to fetch view counter data', _context2.t0);
                                this.elem.innerHTML = 0;

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 10]]);
            }));

            function requestViewCount() {
                return _ref2.apply(this, arguments);
            }

            return requestViewCount;
        }()
    }]);
    return ViewCounter;
}();

exports.default = ViewCounter;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(123), __esModule: true };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(130);

var _assign2 = _interopRequireDefault(_assign);

exports.default = function (selector, width) {
    return function () {
        var catfish = document.querySelector('[id^=' + selector + ']');
        var catfishStyle = {
            position: 'fixed',
            zIndex: '9999',
            bottom: '0',
            left: '0',
            right: '0',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: width + 'px',
            display: 'block'
        };
        (0, _assign2.default)(catfish.style, catfishStyle);

        var closeButton = document.createElement('p');
        closeButton.innerText = 'x';
        closeButton.id = 'desktop-catfish-close-button';

        var closeButtonStyle = {
            position: 'absolute',
            margin: '0',
            left: '93%',
            top: '-33px',
            backgroundColor: '#555',
            color: '#fff',
            fontSize: '21px',
            padding: '8px 10px 10px',
            border: 'none',
            borderRadius: '35px',
            textAlign: 'center',
            lineHeight: '0.5',
            userSelect: 'none',
            cursor: 'pointer'
        };
        (0, _assign2.default)(closeButton.style, closeButtonStyle);

        closeButton.addEventListener('click', function () {
            catfish.remove();
        });

        catfish.appendChild(closeButton);
    };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _destroyAdv2.default)(['mobileBrandingSmall', 'mobileBrandingSmallBannerWrapper']);

    if (document.getElementById('mobile-branding-inline-style') === null) {
        var style = document.createElement('style');
        style.innerHTML = '\n        #mobileBrandingSmallBannerWrapper {\n            display: none;\n        }';
        style.id = 'mobile-branding-inline-style';
        document.head.appendChild(style);
    }
};

var _destroyAdv = __webpack_require__(93);

var _destroyAdv2 = _interopRequireDefault(_destroyAdv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(3);
var getKeys = __webpack_require__(23);
var toIObject = __webpack_require__(14);
var isEnum = __webpack_require__(50).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(108), __esModule: true };

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(109);
module.exports = __webpack_require__(0).Array.from;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(9);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(24);
var call = __webpack_require__(58);
var isArrayIter = __webpack_require__(59);
var toLength = __webpack_require__(26);
var createProperty = __webpack_require__(110);
var getIterFn = __webpack_require__(40);

$export($export.S + $export.F * !__webpack_require__(60)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(8);
var createDesc = __webpack_require__(17);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt) {
    var dns = opt.dns;
    var appVersion = opt.appVersion;
    var galleries = {};
    window.galleries = galleries;
    var gallerySelector = 'div[id*="additonal-photo-gallery-"].photo-gallery:not(.ug-gallery-wrapper)';
    var galleryList = document.querySelectorAll(gallerySelector);

    if (galleryList.length >= 1) {
        if ('IntersectionObserver' in window) {
            var target = galleryList[0].previousElementSibling !== null ? galleryList[0].previousElementSibling : galleryList[0];
            if (target.tagName.toLowerCase() === 'script') target = galleryList[0];
            var io = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting) {
                    initAllGalleryDependencies();
                    io.unobserve(target);
                }
            }, {});
            io.observe(target);
        } else {
            initAllGalleryDependencies();
        }
    }

    function initAllGalleryDependencies() {
        cleanGalleryContent(gallerySelector);
        (0, _loadCSS2.default)(dns + 'assets/tv24/lib/unitegallery/css/main_gallery.min.css?v=' + appVersion);
        var script = (0, _loadScript2.default)(dns + 'assets/tv24/lib/unitegallery/js/gallery_main.min.js?v=' + appVersion);
        script.onload = function () {
            initGallery(galleryList);
        };
    }

    function cleanGalleryContent(gallerySelector) {
        $(gallerySelector).find('noscript').remove();
        $(gallerySelector).find('script').remove();
    }

    function initGallery(galleryList) {
        galleryList.forEach(function (item) {
            var photoGalleryCfg = {
                /*thumb style begin*/
                thumb_border_effect: false,
                thumb_color_overlay_effect: true,
                thumb_overlay_color: "#ffffff",
                thumb_overlay_reverse: false,
                thumb_overlay_opacity: 0.4,
                /*thumb style end*/
                theme_hide_panel_under_width: 480, //hide panel under certain browser width, if null, don't hide

                slider_scale_mode: "fit", //scale mode for main image in gallery
                slider_scale_mode_fullscreen: "full", //fit, down, full scale mode on fullscreen.
                slider_loader_type: 7, //shape of the loader (1-7)
                slider_controls_always_on: true, //hide controls
                slider_progress_indicator_type: "bar", //progress bar type
                slider_progressbar_color: "#333" //progress bar color
            };

            var galleryName = item.id;
            var gallerySelector = '#' + galleryName;

            galleries[galleryName] = $(gallerySelector).unitegallery(photoGalleryCfg);

            $(gallerySelector + " > div.ug-top-right-wraper > div.ug-default-button-play").click(function () {
                $(this).toggleClass("ug-stop-mode");
                galleries[galleryName].togglePlay();
            });

            $(gallerySelector + " > div.ug-top-right-wraper > div.ug-default-button-fullscreen").click(function () {
                galleries[galleryName].toggleFullscreen();
            });

            // Fix showing thumbnails
            if (typeof galleries[galleryName] != 'undefined') {
                galleries[galleryName].resize(document.getElementById(galleryName).offsetWidth - 1);
            }
        });
    }
};

var _loadScript = __webpack_require__(53);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _loadCSS = __webpack_require__(100);

var _loadCSS2 = _interopRequireDefault(_loadCSS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var photoComparators = document.querySelectorAll(".before-after:not(.inited)");

    if (photoComparators.length > 0) {
        if (photoComparators[0].classList.contains('inited')) {
            return;
        }
        photoComparators[0].classList.add('inited');
        if ('IntersectionObserver' in window) {
            var target = photoComparators[0];
            if (target !== null) {
                var io = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting) {
                        initPhotoComparator();
                        io.unobserve(target);
                    }
                }, {});
                io.observe(target);
            } else {
                firePhotoComparator();
            }
        } else {
            initPhotoComparator();
        }
    }

    function initPhotoComparator() {
        var script = (0, _loadScript2.default)('assets/tv24/lib/jquery.twentytwenty.min.js');
        (0, _loadCSS2.default)('assets/tv24/stylesheets/twentytwenty.min.css');

        script.onload = function () {
            firePhotoComparator();
        };
    }

    function firePhotoComparator() {
        $(".before-after").twentytwenty();
    }
};

var _loadScript = __webpack_require__(53);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _loadCSS = __webpack_require__(100);

var _loadCSS2 = _interopRequireDefault(_loadCSS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(36);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(37);

var _createClass3 = _interopRequireDefault(_createClass2);

var _detectOs = __webpack_require__(79);

var _detectOs2 = _interopRequireDefault(_detectOs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinksTooltip = function () {
    function LinksTooltip() {
        (0, _classCallCheck3.default)(this, LinksTooltip);

        if (_detectOs2.default.isMobile()) {
            return;
        }
        this.linksForTooltip = $('a.more-link[data-name][data-photosrc]');
        if ($(this.linksForTooltip).length === 0) {
            return;
        }

        this.initTooltips(this.linksForTooltip);
    }

    (0, _createClass3.default)(LinksTooltip, [{
        key: 'initTooltips',
        value: function initTooltips(links) {
            $(links).hover(function () {
                var a = $(this);
                if (!hasTooltip(a)) {
                    buildTooltip(a);
                }

                var halfHeight = $(window).height() / 2;
                if ($(a).offset().top - $(window).scrollTop() < halfHeight) {
                    $('.moreLinkDescr').addClass('moreLinkDescrBottom');
                } else {
                    $('.moreLinkDescr').removeClass('moreLinkDescrBottom');
                }

                var fullWidth = $('#newsSummary').width();
                var halfWidth = fullWidth / 2;
                var rightPosition = fullWidth - ($(a).position().left + $(a).width());

                if (rightPosition < halfWidth) {
                    $(a).find('.moreLinkDescr').addClass('moreLinkDescrLeft');
                } else {
                    $(a).find('.moreLinkDescr').removeClass('moreLinkDescrLeft');
                }
            });

            var hasTooltip = function hasTooltip(a) {
                return $(a).children("span.moreLinkDescr").length > 0;
            };

            function buildTooltip(a) {
                var name = $(a).attr('data-name');
                var photoSrc = $(a).attr('data-photosrc');

                var tooltip = '<span class="moreLinkDescr">\n                    <span class="moreLinkDescrWrap">\n                        <img src="' + photoSrc + '">\n                        <span>' + name + '</span>\n                    </span>\n                 </span>';
                $(a).append(tooltip);
            }
        }
    }]);
    return LinksTooltip;
}();

exports.default = LinksTooltip;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(51);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {

    var anchorList = document.querySelectorAll(".read-also.cke-markup:not(.internal-url)");

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(anchorList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;


            item.classList.add("internal-url");

            var originalLinkContent = item.querySelector('.more-link');
            var linkContent = void 0;
            if (originalLinkContent) {
                linkContent = originalLinkContent.cloneNode(true);
                originalLinkContent.remove();

                var titleContent = document.createElement('div');
                var titleParagraph = document.createElement('p');
                titleParagraph.innerText = item.innerText;

                var titleImageWrap = document.createElement('span');
                var titleImage = document.createElement('img');
                titleImage.src = "assets/tv24/images/read-also-icon.svg";
                titleImage.alt = "read-also-icon";

                titleParagraph.appendChild(titleImageWrap);
                titleImageWrap.appendChild(titleImage);

                titleContent.className = 'read-also-title';
                titleContent.appendChild(titleParagraph);

                item.innerHTML = '';
                item.appendChild(titleContent);

                if (linkContent) {
                    item.appendChild(linkContent);
                }

                var itemChildren = item.innerHTML;

                var wrapper = document.createElement('div');
                wrapper.className = 'read-also-content';

                wrapper.innerHTML = itemChildren;
                item.innerHTML = '';

                item.appendChild(wrapper);

                var imgWrapper = document.createElement('div');
                imgWrapper.className = 'img-wrapper';
                var anchor = item.getElementsByTagName('a')[0];
                if (!anchor) continue;

                var imgSrc = anchor.getAttribute("data-photosrc");

                if (!imgSrc) continue;

                imgWrapper.style.backgroundImage = "url(" + imgSrc + ")";
                item.prepend(imgWrapper);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Infinite Scroll v3.0.6
 * Automatically add next page
 *
 * Licensed GPLv3 for open source use
 * or Infinite Scroll Commercial License for commercial use
 *
 * https://infinite-scroll.com
 * Copyright 2018 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(118),
      __webpack_require__(119),
      __webpack_require__(120),
      __webpack_require__(121),
      __webpack_require__(122),
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})( window, function factory( InfiniteScroll ) {
  return InfiniteScroll;
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// page-load
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( InfiniteScroll ) {
      return factory( window, InfiniteScroll );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, InfiniteScroll ) {

var proto = InfiniteScroll.prototype;

// InfiniteScroll.defaults.append = false;
InfiniteScroll.defaults.loadOnScroll = true;
InfiniteScroll.defaults.checkLastPage = true;
InfiniteScroll.defaults.responseType = 'document';
// InfiniteScroll.defaults.prefill = false;
// InfiniteScroll.defaults.outlayer = null;

InfiniteScroll.create.pageLoad = function() {
  this.canLoad = true;
  this.on( 'scrollThreshold', this.onScrollThresholdLoad );
  this.on( 'load', this.checkLastPage );
  if ( this.options.outlayer ) {
    this.on( 'append', this.onAppendOutlayer );
  }
};

proto.onScrollThresholdLoad = function() {
  if ( this.options.loadOnScroll ) {
    this.loadNextPage();
  }
};

proto.loadNextPage = function() {
  if ( this.isLoading || !this.canLoad ) {
    return;
  }

  var path = this.getAbsolutePath();
  this.isLoading = true;

  var onLoad = function( response ) {
    this.onPageLoad( response, path );
  }.bind( this );

  var onError = function( error ) {
    this.onPageError( error, path );
  }.bind( this );

  var onLast = function( response ) {
    this.lastPageReached( response, path );
  }.bind( this );

  request( path, this.options.responseType, onLoad, onError, onLast );
  this.dispatchEvent( 'request', null, [ path ] );
};

proto.onPageLoad = function( response, path ) {
  // done loading if not appending
  if ( !this.options.append ) {
    this.isLoading = false;
  }
  this.pageIndex++;
  this.loadCount++;
  this.dispatchEvent( 'load', null, [ response, path ] );
  this.appendNextPage( response, path );
  return response;
};

proto.appendNextPage = function( response, path ) {
  var optAppend = this.options.append;
  // do not append json
  var isDocument = this.options.responseType == 'document';
  if ( !isDocument || !optAppend ) {
    return;
  }

  var items = response.querySelectorAll( optAppend );
  var fragment = getItemsFragment( items );
  var appendReady = function () {
    this.appendItems( items, fragment );
    this.isLoading = false;
    this.dispatchEvent( 'append', null, [ response, path, items ] );
  }.bind( this );

  // TODO add hook for option to trigger appendReady
  if ( this.options.outlayer ) {
    this.appendOutlayerItems( fragment, appendReady );
  } else {
    appendReady();
  }
};

proto.appendItems = function( items, fragment ) {
  if ( !items || !items.length ) {
    return;
  }
  // get fragment if not provided
  fragment = fragment || getItemsFragment( items );
  refreshScripts( fragment );
  this.element.appendChild( fragment );
};

function getItemsFragment( items ) {
  // add items to fragment
  var fragment = document.createDocumentFragment();
  for ( var i=0; items && i < items.length; i++ ) {
    fragment.appendChild( items[i] );
  }
  return fragment;
}

// replace <script>s with copies so they load
// <script>s added by InfiniteScroll will not load
// similar to https://stackoverflow.com/questions/610995
function refreshScripts( fragment ) {
  var scripts = fragment.querySelectorAll('script');
  for ( var i=0; i < scripts.length; i++ ) {
    var script = scripts[i];
    var freshScript = document.createElement('script');
    copyAttributes( script, freshScript );
    // copy inner script code. #718, #782
    freshScript.innerHTML = script.innerHTML;
    script.parentNode.replaceChild( freshScript, script );
  }
}

function copyAttributes( fromNode, toNode ) {
  var attrs = fromNode.attributes;
  for ( var i=0; i < attrs.length; i++ ) {
    var attr = attrs[i];
    toNode.setAttribute( attr.name, attr.value );
  }
}

// ----- outlayer ----- //

proto.appendOutlayerItems = function( fragment, appendReady ) {
  var imagesLoaded = InfiniteScroll.imagesLoaded || window.imagesLoaded;
  if ( !imagesLoaded ) {
    console.error('[InfiniteScroll] imagesLoaded required for outlayer option');
    this.isLoading = false;
    return;
  }
  // append once images loaded
  imagesLoaded( fragment, appendReady );
};

proto.onAppendOutlayer = function( response, path, items ) {
  this.options.outlayer.appended( items );
};

// ----- checkLastPage ----- //

// check response for next element
proto.checkLastPage = function( response, path ) {
  var checkLastPage = this.options.checkLastPage;
  if ( !checkLastPage ) {
    return;
  }

  var pathOpt = this.options.path;
  // if path is function, check if next path is truthy
  if ( typeof pathOpt == 'function' ) {
    var nextPath = this.getPath();
    if ( !nextPath ) {
      this.lastPageReached( response, path );
      return;
    }
  }
  // get selector from checkLastPage or path option
  var selector;
  if ( typeof checkLastPage == 'string' ) {
    selector = checkLastPage;
  } else if ( this.isPathSelector ) {
    // path option is selector string
    selector = pathOpt;
  }
  // check last page for selector
  // bail if no selector or not document response
  if ( !selector || !response.querySelector ) {
    return;
  }
  // check if response has selector
  var nextElem = response.querySelector( selector );
  if ( !nextElem ) {
    this.lastPageReached( response, path );
  }
};

proto.lastPageReached = function( response, path ) {
  this.canLoad = false;
  this.dispatchEvent( 'last', null, [ response, path ] );
};

// ----- error ----- //

proto.onPageError = function( error, path ) {
  this.isLoading = false;
  this.canLoad = false;
  this.dispatchEvent( 'error', null, [ error, path ] );
  return error;
};

// -------------------------- prefill -------------------------- //

InfiniteScroll.create.prefill = function() {
  if ( !this.options.prefill ) {
    return;
  }
  var append = this.options.append;
  if ( !append ) {
    console.error( 'append option required for prefill. Set as :' + append );
    return;
  }
  this.updateMeasurements();
  this.updateScroller();
  this.isPrefilling = true;
  this.on( 'append', this.prefill );
  this.once( 'error', this.stopPrefill );
  this.once( 'last', this.stopPrefill );
  this.prefill();
};

proto.prefill = function() {
  var distance = this.getPrefillDistance();
  this.isPrefilling = distance >= 0;
  if ( this.isPrefilling ) {
    this.log('prefill');
    this.loadNextPage();
  } else {
    this.stopPrefill();
  }
};

proto.getPrefillDistance = function() {
  // element scroll
  if ( this.options.elementScroll ) {
    return this.scroller.clientHeight - this.scroller.scrollHeight;
  }
  // window
  return this.windowHeight - this.element.clientHeight;
};

proto.stopPrefill = function() {
  this.log('stopPrefill');
  this.off( 'append', this.prefill );
};

// -------------------------- request -------------------------- //

function request( url, responseType, onLoad, onError, onLast ) {
  var req = new XMLHttpRequest();
  req.open( 'GET', url, true );
  // set responseType document to return DOM
  req.responseType = responseType || '';

  // set X-Requested-With header to check that is ajax request
  req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

  req.onload = function() {
    if ( req.status == 200 ) {
      onLoad( req.response );
    } else if ( req.status == 204 ) {
      onLast( req.response );
    } else {
      // not 200 OK, error
      var error = new Error( req.statusText );
      onError( error );
    }
  };

  // Handle network errors
  req.onerror = function() {
    var error = new Error( 'Network error requesting ' + url );
    onError( error );
  };

  req.send();
}

// --------------------------  -------------------------- //

return InfiniteScroll;

}));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// scroll-watch
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(41),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( InfiniteScroll, utils ) {
      return factory( window, InfiniteScroll, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, InfiniteScroll, utils ) {

var proto = InfiniteScroll.prototype;

// default options
InfiniteScroll.defaults.scrollThreshold = 400;
// InfiniteScroll.defaults.elementScroll = null;

InfiniteScroll.create.scrollWatch = function() {
  // events
  this.pageScrollHandler = this.onPageScroll.bind( this );
  this.resizeHandler = this.onResize.bind( this );

  var scrollThreshold = this.options.scrollThreshold;
  var isEnable = scrollThreshold || scrollThreshold === 0;
  if ( isEnable ) {
    this.enableScrollWatch();
  }
};

InfiniteScroll.destroy.scrollWatch = function() {
  this.disableScrollWatch();
};

proto.enableScrollWatch = function() {
  if ( this.isScrollWatching ) {
    return;
  }
  this.isScrollWatching = true;
  this.updateMeasurements();
  this.updateScroller();
  // TODO disable after error?
  this.on( 'last', this.disableScrollWatch );
  this.bindScrollWatchEvents( true );
};

proto.disableScrollWatch = function() {
  if ( !this.isScrollWatching ) {
    return;
  }
  this.bindScrollWatchEvents( false );
  delete this.isScrollWatching;
};

proto.bindScrollWatchEvents = function( isBind ) {
  var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
  this.scroller[ addRemove ]( 'scroll', this.pageScrollHandler );
  window[ addRemove ]( 'resize', this.resizeHandler );
};

proto.onPageScroll = InfiniteScroll.throttle( function() {
  var distance = this.getBottomDistance();
  if ( distance <= this.options.scrollThreshold ) {
    this.dispatchEvent('scrollThreshold');
  }
});

proto.getBottomDistance = function() {
  if ( this.options.elementScroll ) {
    return this.getElementBottomDistance();
  } else {
    return this.getWindowBottomDistance();
  }
};

proto.getWindowBottomDistance = function() {
  var bottom = this.top + this.element.clientHeight;
  var scrollY = window.pageYOffset + this.windowHeight;
  return bottom - scrollY;
};

proto.getElementBottomDistance = function() {
  var bottom = this.scroller.scrollHeight;
  var scrollY = this.scroller.scrollTop + this.scroller.clientHeight;
  return bottom - scrollY;
};

proto.onResize = function() {
  this.updateMeasurements();
};

utils.debounceMethod( InfiniteScroll, 'onResize', 150 );

// --------------------------  -------------------------- //

return InfiniteScroll;

}));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// history
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(41),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( InfiniteScroll, utils ) {
      return factory( window, InfiniteScroll, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, InfiniteScroll, utils ) {

var proto = InfiniteScroll.prototype;

InfiniteScroll.defaults.history = 'replace';
// InfiniteScroll.defaults.historyTitle = false;

var link = document.createElement('a');

// ----- create/destroy ----- //

InfiniteScroll.create.history = function() {
  if ( !this.options.history ) {
    return;
  }
  // check for same origin
  link.href = this.getAbsolutePath();
  // MS Edge does not have origin on link https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12236493/
  var linkOrigin = link.origin || link.protocol + '//' + link.host;
  var isSameOrigin = linkOrigin == location.origin;
  if ( !isSameOrigin ) {
    console.error( '[InfiniteScroll] cannot set history with different origin: ' +
      link.origin + ' on ' + location.origin +
      ' . History behavior disabled.' );
    return;
  }

  // two ways to handle changing history
  if ( this.options.append ) {
    this.createHistoryAppend();
  } else {
    this.createHistoryPageLoad();
  }
};

proto.createHistoryAppend = function() {
  this.updateMeasurements();
  this.updateScroller();
  // array of scroll positions of appended pages
  this.scrollPages = [
    {
      // first page
      top: 0,
      path: location.href,
      title: document.title,
    }
  ];
  this.scrollPageIndex = 0;
  // events
  this.scrollHistoryHandler = this.onScrollHistory.bind( this );
  this.unloadHandler = this.onUnload.bind( this );
  this.scroller.addEventListener( 'scroll', this.scrollHistoryHandler );
  this.on( 'append', this.onAppendHistory );
  this.bindHistoryAppendEvents( true );
};

proto.bindHistoryAppendEvents = function( isBind ) {
  var addRemove = isBind ? 'addEventListener' : 'removeEventListener';
  this.scroller[ addRemove ]( 'scroll', this.scrollHistoryHandler );
  window[ addRemove ]( 'unload', this.unloadHandler );
};

proto.createHistoryPageLoad = function() {
  this.on( 'load', this.onPageLoadHistory );
};

InfiniteScroll.destroy.history =
proto.destroyHistory = function() {
  var isHistoryAppend = this.options.history && this.options.append;
  if ( isHistoryAppend ) {
    this.bindHistoryAppendEvents( false );
  }
};

// ----- append history ----- //

proto.onAppendHistory = function( response, path, items ) {
  // do not proceed if no items. #779
  if ( !items || !items.length ) {
    return;
  }
  var firstItem = items[0];
  var elemScrollY = this.getElementScrollY( firstItem );
  // resolve path
  link.href = path;
  // add page data to hash
  this.scrollPages.push({
    top: elemScrollY,
    path: link.href,
    title: response.title,
  });
};

proto.getElementScrollY = function( elem ) {
  if ( this.options.elementScroll ) {
    return this.getElementElementScrollY( elem );
  } else {
    return this.getElementWindowScrollY( elem );
  }
};

proto.getElementWindowScrollY = function( elem ) {
  var rect = elem.getBoundingClientRect();
  return rect.top + window.pageYOffset;
};

// wow, stupid name
proto.getElementElementScrollY = function( elem ) {
  return elem.offsetTop - this.top;
};

proto.onScrollHistory = function() {
  // cycle through positions, find biggest without going over
  var scrollViewY = this.getScrollViewY();
  var pageIndex, page;
  for ( var i=0; i < this.scrollPages.length; i++ ) {
    var scrollPage = this.scrollPages[i];
    if ( scrollPage.top >= scrollViewY ) {
      break;
    }
    pageIndex = i;
    page = scrollPage;
  }
  // set history if changed
  if ( pageIndex != this.scrollPageIndex ) {
    this.scrollPageIndex = pageIndex;
    this.setHistory( page.title, page.path );
  }
};

utils.debounceMethod( InfiniteScroll, 'onScrollHistory', 150 );

proto.getScrollViewY = function() {
  if ( this.options.elementScroll ) {
    return this.scroller.scrollTop + this.scroller.clientHeight/2;
  } else {
    return window.pageYOffset + this.windowHeight/2;
  }
};

proto.setHistory = function( title, path ) {
  var optHistory = this.options.history;
  var historyMethod = optHistory && history[ optHistory + 'State' ];
  if ( !historyMethod ) {
    return;
  }

  history[ optHistory + 'State' ]( null, title, path );

  if ( this.options.historyTitle ) {
    document.title = title;
  }

  this.dispatchEvent( 'history', null, [ title, path ] );
};

// scroll to top to prevent initial scroll-reset after page refresh
// https://stackoverflow.com/a/18633915/182183
proto.onUnload = function() {
  var pageIndex = this.scrollPageIndex;
  if ( pageIndex === 0 ) {
    return;
  }
  // calculate where scroll position would be on refresh
  var scrollPage = this.scrollPages[ pageIndex ];
  var scrollY = window.pageYOffset - scrollPage.top + this.top;
  // disable scroll event before setting scroll #679
  this.destroyHistory();
  scrollTo( 0, scrollY );
};

// ----- load history ----- //

// update URL
proto.onPageLoadHistory = function( response, path ) {
  this.setHistory( response.title, path );
};

// --------------------------  -------------------------- //

return InfiniteScroll;

}));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// button
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(41),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( InfiniteScroll, utils ) {
      return factory( window, InfiniteScroll, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, InfiniteScroll, utils ) {

// InfiniteScroll.defaults.button = null;

InfiniteScroll.create.button = function() {
  var buttonElem = utils.getQueryElement( this.options.button );
  if ( buttonElem ) {
    this.button = new InfiniteScrollButton( buttonElem, this );
    return;
  }
};

InfiniteScroll.destroy.button = function() {
  if ( this.button ) {
    this.button.destroy();
  }
};

// -------------------------- InfiniteScrollButton -------------------------- //

function InfiniteScrollButton( element, infScroll ) {
  this.element = element;
  this.infScroll = infScroll;
  // events
  this.clickHandler = this.onClick.bind( this );
  this.element.addEventListener( 'click', this.clickHandler );
  infScroll.on( 'request', this.disable.bind( this ) );
  infScroll.on( 'load', this.enable.bind( this ) );
  infScroll.on( 'error', this.hide.bind( this ) );
  infScroll.on( 'last', this.hide.bind( this ) );
}

InfiniteScrollButton.prototype.onClick = function( event ) {
  event.preventDefault();
  this.infScroll.loadNextPage();
};

InfiniteScrollButton.prototype.enable = function() {
  this.element.removeAttribute('disabled');
};

InfiniteScrollButton.prototype.disable = function() {
  this.element.disabled = 'disabled';
};

InfiniteScrollButton.prototype.hide = function() {
  this.element.style.display = 'none';
};

InfiniteScrollButton.prototype.destroy = function() {
  this.element.removeEventListener( 'click', this.clickHandler );
};

// --------------------------  -------------------------- //

InfiniteScroll.Button = InfiniteScrollButton;

return InfiniteScroll;

}));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// status
( function( window, factory ) {
  // universal module definition
  /* globals define, module, require */
  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(28),
      __webpack_require__(41),
    ], __WEBPACK_AMD_DEFINE_RESULT__ = (function( InfiniteScroll, utils ) {
      return factory( window, InfiniteScroll, utils );
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

}( window, function factory( window, InfiniteScroll, utils ) { 

var proto = InfiniteScroll.prototype;

// InfiniteScroll.defaults.status = null;

InfiniteScroll.create.status = function() {
  var statusElem = utils.getQueryElement( this.options.status );
  if ( !statusElem ) {
    return;
  }
  // elements
  this.statusElement = statusElem;
  this.statusEventElements = {
    request: statusElem.querySelector('.infinite-scroll-request'),
    error: statusElem.querySelector('.infinite-scroll-error'),
    last: statusElem.querySelector('.infinite-scroll-last'),
  };
  // events
  this.on( 'request', this.showRequestStatus );
  this.on( 'error', this.showErrorStatus );
  this.on( 'last', this.showLastStatus );
  this.bindHideStatus('on');
};

proto.bindHideStatus = function( bindMethod ) {
  var hideEvent = this.options.append ? 'append' : 'load';
  this[ bindMethod ]( hideEvent, this.hideAllStatus );
};

proto.showRequestStatus = function() {
  this.showStatus('request');
};

proto.showErrorStatus = function() {
  this.showStatus('error');
};

proto.showLastStatus = function() {
  this.showStatus('last');
  // prevent last then append event race condition from showing last status #706
  this.bindHideStatus('off');
};

proto.showStatus = function( eventName ) {
  show( this.statusElement );
  this.hideStatusEventElements();
  var eventElem = this.statusEventElements[ eventName ];
  show( eventElem );
};

proto.hideAllStatus = function() {
  hide( this.statusElement );
  this.hideStatusEventElements();
};

proto.hideStatusEventElements = function() {
  for ( var type in this.statusEventElements ) {
    var eventElem = this.statusEventElements[ type ];
    hide( eventElem );
  }
};

// --------------------------  -------------------------- //

function hide( elem ) {
  setDisplay( elem, 'none' );
}

function show( elem ) {
  setDisplay( elem, 'block' );
}

function setDisplay( elem, value ) {
  if ( elem ) {
    elem.style.display = value;
  }
}

// --------------------------  -------------------------- //

return InfiniteScroll;

}));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(24);
var $keys = __webpack_require__(23);

__webpack_require__(89)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var prevPreloder = document.getElementById('infinit-scroll-preloader');
    if (prevPreloder) {
        prevPreloder.remove();
    }

    var preloaderWrapper = document.createElement('div');
    preloaderWrapper.classList.add('page-load-status');
    preloaderWrapper.innerHTML = '' + '<div id="infinit-scroll-preloader" class="loader-ellips">\n' + '  <span class="loader-ellips__dot"></span>\n' + '  <span class="loader-ellips__dot"></span>\n' + '  <span class="loader-ellips__dot"></span>\n' + '  <span class="loader-ellips__dot"></span>\n' + '</div>';

    (0, _getLastNews2.default)().appendChild(preloaderWrapper);
};

var _getLastNews = __webpack_require__(126);

var _getLastNews2 = _interopRequireDefault(_getLastNews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var loadedNews = document.querySelectorAll('.next-article');
    return loadedNews[loadedNews.length - 1];
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(51);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    var showMoreButtons = document.querySelectorAll('.tags .show-all');

    var _loop = function _loop(showMoreButton) {
        showMoreButton.onclick = function () {
            showMoreButton.closest('.tags.adv-destroy').classList.toggle("active");
            showMoreButton.classList.toggle("active");
        };
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(showMoreButtons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var showMoreButton = _step.value;

            _loop(showMoreButton);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var tagWrappers = document.querySelectorAll('.tags.adv-destroy');

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(tagWrappers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tagWrapper = _step2.value;

            var showAllBtn = tagWrapper.querySelector('.tags .show-all');
            var showAllBtnWidth = showAllBtn.offsetWidth;

            if (!tagWrapper.classList.contains('inited')) {
                var summ = 0;

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(tagWrapper.querySelectorAll('.tags-list-wrapper a')), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        summ += item.offsetWidth;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                if (summ > tagWrapper.offsetWidth - showAllBtnWidth) {
                    tagWrapper.classList.add('show');
                    tagWrapper.querySelector('.tags-item-list').style.display = 'block';
                    showAllBtn.classList.remove('hidden');
                } else {
                    showAllBtn.classList.add('hidden');
                }
            }

            tagWrapper.classList.add('inited');
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (path) {
    var tmp = path.match(/(_n|objectId=)(\d+)/i);
    return tmp[2];
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (title, path, firstInit) {
    var newsTitles = document.querySelectorAll('h1');
    newsTitles.forEach(function (item) {
        if (firstInit || path === item.getAttribute('path')) {
            var closestOnTheIOTrackingElement = item.closest('.next-article').querySelector('.ontheioViewTacking');
            if (closestOnTheIOTrackingElement !== null) closestOnTheIOTrackingElement.setAttribute('data-io-article-url', window.location.href);
        }
    });
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(131), __esModule: true };

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(133) });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(3);
var getKeys = __webpack_require__(23);
var gOPS = __webpack_require__(91);
var pIE = __webpack_require__(50);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(44);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt, path, newsIndex) {
    var newsId = typeof path !== 'undefined' ? path.match(/(_n|objectId=)(\d+)/i)[2] : opt.newsId;

    if (opt.subsiteName === 'education') {
        (0, _renderMarketplaceAdv2.default)(newsId, newsIndex);
        if (opt.subsiteName === 'sport') {
            (0, _renderSportAdv2.default)(newsIndex);
        }
    } else if (opt.subsiteName === 'fun') {
        (0, _renderFunAdv2.default)(newsId);
    } else {
        (0, _renderFirstAdv2.default)(newsId, 100, newsIndex, opt);
        (0, _renderSecondAdv2.default)(newsId, 200, newsIndex, opt);
        (0, _renderThirdAdv2.default)(newsId, 300, newsIndex, opt);
    }
};

var _renderFirstAdv = __webpack_require__(161);

var _renderFirstAdv2 = _interopRequireDefault(_renderFirstAdv);

var _renderSecondAdv = __webpack_require__(162);

var _renderSecondAdv2 = _interopRequireDefault(_renderSecondAdv);

var _renderThirdAdv = __webpack_require__(163);

var _renderThirdAdv2 = _interopRequireDefault(_renderThirdAdv);

var _renderMarketplaceAdv = __webpack_require__(164);

var _renderMarketplaceAdv2 = _interopRequireDefault(_renderMarketplaceAdv);

var _renderSportAdv = __webpack_require__(165);

var _renderSportAdv2 = _interopRequireDefault(_renderSportAdv);

var _renderFunAdv = __webpack_require__(166);

var _renderFunAdv2 = _interopRequireDefault(_renderFunAdv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsIndex) {
    var advPlacesOnPages = document.querySelectorAll('.adv-between-newses:not(.inited)');
    if (advPlacesOnPages != null && advPlacesOnPages.length > 0) {
        var advPlace = advPlacesOnPages[0];
        var wrapperId = 'adv-between-newses' + newsIndex;
        advPlace.id = wrapperId;

        if (newsIndex <= 5) {
            if (window.innerWidth < 640) {
                (0, _getDFPBlock2.default)('/56301415/24tv_between_news_mobile_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px', function () {
                    advPlace.classList.add('inited');
                });
            } else {
                (0, _getDFPBlock2.default)('/56301415/24tv_between_news_desktop_(2-5)', [[1, 1], [580, 400]], wrapperId, '100%', function () {
                    advPlace.classList.add('inited');
                });
            }
        } else {
            if (window.innerWidth < 640) {
                (0, _getDFPBlock2.default)('/56301415/24tv_between_news_mobile_(6-11)', [[1, 1], [300, 250]], wrapperId, '300px', function () {
                    advPlace.classList.add('inited');
                });
            } else {
                (0, _getDFPBlock2.default)('/56301415/24tv_between_news_desktop_(6-11)', [[1, 1], [580, 400]], wrapperId, '100%', function () {
                    advPlace.classList.add('inited');
                });
            }
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt, newsId) {
    if (!showMobileBranding) {
        (0, _destroyMobileBranding2.default)();
        return;
    }

    if (opt.showMobileBrandingOnSecondNews) {
        (0, _destroyMobileBranding2.default)();
    }

    if (document.getElementById('mobileBranding' + newsId) !== null) {
        return;
    }

    var headerQuerySelector = opt.subsiteName === '24' || opt.subsiteName === 'lviv' || opt.subsiteName === 'kyivnews' ? 'header > div.container' : 'header > div.grid-container';

    var headerHeight = opt.subsiteName === 'lviv' || opt.subsiteName === 'kyivnews' ? 50 : 80;

    if (document.getElementById('mobileBrandingPlace' + newsId) === null) {
        var mobileBrandingWrapper = document.createElement('div');
        mobileBrandingWrapper.id = 'mobileBrandingPlace' + newsId;
        mobileBrandingWrapper.style.zIndex = 9;
        document.querySelector('header').after(mobileBrandingWrapper);
    }

    window.mobileBrandingConfig = {
        mobileBrandingPlace: '#mobileBrandingPlace' + newsId,
        headerHeight: headerHeight,
        isHeaderSticky: true,
        headerQuerySelector: headerQuerySelector
    };

    var mobileBrandingDFPPlace = document.createElement('div');
    mobileBrandingDFPPlace.id = 'mobileBranding' + newsId;
    mobileBrandingDFPPlace.style.display = 'none';
    if (document.getElementById('mobile-branding') != null) {
        document.getElementById('mobile-branding').appendChild(mobileBrandingDFPPlace);
    }

    var mobileBrandingTrigger = document.getElementById('mobileBrandingPlace' + newsId) != null ? 'mobileBrandingPlace' + newsId : 'mobile-branding';
    (0, _advDelayLoad2.default)(function () {
        if (mobileBrandingDFPPlace.getAttribute('inited') === null) {
            document.getElementById(mobileBrandingTrigger).style.order = '-2';
            initMobileBranding();
        }
    }, mobileBrandingTrigger, '1px');

    function initMobileBranding() {
        _advCore2.default.defineDfpSlot({
            "name": opt.mobileBrandingSlotId,
            "sizes": [[1, 1], [2, 2], [1, 2]],
            "id": 'mobileBranding' + newsId,
            "targeting": opt.dfpTargeting,
            "callback": function callback(e) {
                if (!e.isEmpty) {
                    if (e.size[0] === 1 && e.size[1] === 2) {
                        (0, _destroyMobileBranding2.default)();

                        document.addEventListener("MobileBrandingSmallBannerShowed", function () {
                            document.querySelectorAll('.mobileBrandingPlace').forEach(function (node) {
                                node.style.top = '0px';
                            });

                            if (document.getElementById('mobile-branding-inline-style') !== null) {
                                document.getElementById('mobile-branding-inline-style').remove();
                            }
                        });

                        // document.addEventListener("MobileBrandingSmallBannerClosed", function () {
                        //     contentWrapper.style.paddingTop = rightColPadding + 'px'
                        // });
                        // document.addEventListener("MobileBrandingBigBannerHidden", function () {
                        //     console.log("MobileBrandingBigBannerHidden");
                        // });
                    }
                } else {
                    if (!opt.isMarketplace) {
                        (0, _createCatfish2.default)(opt);
                    }
                    hideMobileBrandingPlace();
                }
            }
        });

        googletag.cmd.push(function () {
            googletag.display('mobileBranding' + newsId);
        });

        mobileBrandingDFPPlace.setAttribute('inited', '');
    }

    function hideMobileBrandingPlace() {
        var mobileBrandingPlace = document.getElementById(mobileBrandingTrigger);
        if (mobileBrandingPlace !== null) {
            mobileBrandingPlace.style.display = 'none';
        }
    }
};

var _advDelayLoad = __webpack_require__(94);

var _advDelayLoad2 = _interopRequireDefault(_advDelayLoad);

var _advCore = __webpack_require__(92);

var _advCore2 = _interopRequireDefault(_advCore);

var _createCatfish = __webpack_require__(90);

var _createCatfish2 = _interopRequireDefault(_createCatfish);

var _destroyMobileBranding = __webpack_require__(104);

var _destroyMobileBranding2 = _interopRequireDefault(_destroyMobileBranding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt, newsId) {
    var dfpWrapper = document.getElementById('desktopBrandingDFP');
    var brandingWrapper = document.createElement('div');
    brandingWrapper.id = 'desktopBranding' + newsId;

    if (document.getElementById(brandingWrapper.id) != null) {
        return;
    } else if (dfpWrapper !== null) {
        dfpWrapper.appendChild(brandingWrapper);
    } else {
        return;
    }

    _advCore2.default.defineDfpSlot({
        'name': opt.desktopBrandingSlotId,
        'sizes': [1, 1],
        'id': 'desktopBranding' + newsId,
        'targeting': opt.dfpTargeting,
        'callback': function callback(e) {
            if (e.isEmpty && window.innerWidth >= 1360) {
                // advCore.defineDfpSlot({
                //     'name': '/56301415/24tv_160x600_sticky_left',
                //     'sizes': [[160, 600], [120, 600]],
                //     'id': 'div-gpt-ad-1478690913385-0',
                //     'targeting': opt.dfpTargeting,
                //     'callback': function (e) {
                //         document.getElementById('sticky_left').style.display = 'block'
                //     }
                // });
                // advCore.defineDfpSlot({
                //     'name': '/56301415/24tv_160x600_sticky_rigth',
                //     'sizes': [[160, 600], [120, 600]],
                //     'id': 'div-gpt-ad-1478690913385-1',
                //     'targeting': opt.dfpTargeting,
                //     'callback': function (e) {
                //         document.getElementById('sticky_right').style.display = 'block'
                //     }
                // });
                //
                // googletag.cmd.push(function () {
                //     googletag.display('div-gpt-ad-1478690913385-0');
                // });
                // googletag.cmd.push(function () {
                //     googletag.display('div-gpt-ad-1478690913385-1');
                // });
            }
        }
    });

    googletag.cmd.push(function () {
        googletag.display('desktopBranding' + newsId);
    });
};

var _advCore = __webpack_require__(92);

var _advCore2 = _interopRequireDefault(_advCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    if (document.getElementById('newsAnnotation') === null) {
        return;
    }

    if (window.innerWidth < 1000) {
        return;
    }

    (0, _createIntersectionObserver2.default)('#newsAnnotation', renderCatFish);

    function renderCatFish() {
        (0, _destroyCatfish2.default)();
        var mobileCatfishPlace = document.getElementById('mobile-banner-zone');
        if (mobileCatfishPlace !== null) {
            var catfishId = 'catfish-desktop-' + Math.round(Math.random() * 1000000);
            var catfishWrapper = document.createElement('div');
            catfishWrapper.id = catfishId;
            mobileCatfishPlace.appendChild(catfishWrapper);

            var computeDesktopCatfish = (0, _styleCatfish2.default)('mobile-banner-zone', 970);
            (0, _getDFPBlock2.default)('/56301415/finance24_catfish', [[970, 90], [1, 1]], catfishId, '970px', computeDesktopCatfish, undefined);
        }
    }
};

var _createIntersectionObserver = __webpack_require__(76);

var _createIntersectionObserver2 = _interopRequireDefault(_createIntersectionObserver);

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

var _destroyCatfish = __webpack_require__(77);

var _destroyCatfish2 = _interopRequireDefault(_destroyCatfish);

var _styleCatfish = __webpack_require__(103);

var _styleCatfish2 = _interopRequireDefault(_styleCatfish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (opt) {
    var dns = opt.dns;
    var appVersion = opt.appVersion;
    var mainPhotoGallery = void 0;
    var gallerySelector = 'main-photo-gallery-' + opt.newsId;
    $('#main-photo-gallery').attr('id', gallerySelector);
    var gallery = document.getElementById(gallerySelector);

    var reinitMainGallery = $('div[id*="main-photo-gallery-"].photo-gallery:not(.ug-gallery-wrapper)');
    if (reinitMainGallery.length > 0) {
        var initAllGalleryDependencies = function initAllGalleryDependencies() {

            cleanGalleryContent(gallerySelector);

            var unitegalleryStylesheet = $('#unitegallery-stylesheet');
            if (unitegalleryStylesheet.length === 0) {
                (0, _loadCSS2.default)(dns + 'assets/tv24/lib/unitegallery/css/main_gallery.min.css?v=' + appVersion);
                var script = (0, _loadScript2.default)(dns + 'assets/tv24/lib/unitegallery/js/gallery_main.min.js?v=' + appVersion);
                script.onload = function () {
                    initGallery(gallery);
                };
            } else {
                initGallery(gallery);
            }
        };

        var cleanGalleryContent = function cleanGalleryContent(gallerySelector) {
            var gallery = $('#' + gallerySelector);
            gallery.find('noscript').remove();
            gallery.find('script').remove();
        };

        var initGallery = function initGallery(gallery) {
            $(function () {
                mainPhotoGallery = $(gallery).unitegallery({

                    /*thumb style begin*/
                    thumb_border_effect: false,
                    thumb_color_overlay_effect: true,
                    thumb_overlay_color: "#ffffff",
                    thumb_overlay_reverse: false,
                    thumb_overlay_opacity: 0.4,
                    /*thumb style end*/
                    theme_hide_panel_under_width: 480, //hide panel under certain browser width, if null, don't hide

                    slider_scale_mode: "fit", //scale mode for main image in gallery
                    slider_scale_mode_fullscreen: "full", //fit, down, full scale mode on fullscreen.
                    slider_loader_type: 7, //shape of the loader (1-7)
                    slider_controls_always_on: true, //hide controls
                    slider_progress_indicator_type: "bar", //progress bar type
                    slider_progressbar_color: "#333" //progress bar color
                });

                $(".main-photo-gallery-wrapper .ug-top-right-wraper .ug-default-button-play").click(function () {
                    $(this).toggleClass("ug-stop-mode");
                    mainPhotoGallery.togglePlay();
                });

                $(".main-photo-gallery-wrapper .ug-top-right-wraper .ug-default-button-fullscreen").click(function () {
                    mainPhotoGallery.toggleFullscreen();
                });

                // Fix showing thumbnails
                mainPhotoGallery.resize(gallery.offsetWidth - 1);
            });
        };

        if (gallery !== null) {
            initAllGalleryDependencies();
        }
    }
};

var _loadScript = __webpack_require__(53);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _loadCSS = __webpack_require__(100);

var _loadCSS2 = _interopRequireDefault(_loadCSS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _infiniteScroll = __webpack_require__(115);

var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);

var _getNextPages = __webpack_require__(153);

var _getNextPages2 = _interopRequireDefault(_getNextPages);

var _renderPreloader = __webpack_require__(125);

var _renderPreloader2 = _interopRequireDefault(_renderPreloader);

var _createEventListeners = __webpack_require__(157);

var _createEventListeners2 = _interopRequireDefault(_createEventListeners);

var _createNewsWithinAdv = __webpack_require__(134);

var _createNewsWithinAdv2 = _interopRequireDefault(_createNewsWithinAdv);

var _createAdvBetweenNewses = __webpack_require__(135);

var _createAdvBetweenNewses2 = _interopRequireDefault(_createAdvBetweenNewses);

var _initOnScroll = __webpack_require__(99);

var _initOnScroll2 = _interopRequireDefault(_initOnScroll);

var _reloadOntheio = __webpack_require__(129);

var _reloadOntheio2 = _interopRequireDefault(_reloadOntheio);

var _sendToPiwik = __webpack_require__(31);

var _sendToPiwik2 = _interopRequireDefault(_sendToPiwik);

var _initViewCountForFirstNews = __webpack_require__(169);

var _initViewCountForFirstNews2 = _interopRequireDefault(_initViewCountForFirstNews);

var _createCatfish = __webpack_require__(90);

var _createCatfish2 = _interopRequireDefault(_createCatfish);

var _createIntersectionObserver = __webpack_require__(76);

var _createIntersectionObserver2 = _interopRequireDefault(_createIntersectionObserver);

var _destroyCatfish = __webpack_require__(77);

var _destroyCatfish2 = _interopRequireDefault(_destroyCatfish);

var _renderFinanceCatfish = __webpack_require__(138);

var _renderFinanceCatfish2 = _interopRequireDefault(_renderFinanceCatfish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(opt) {
        var initInfiniteScroll = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var nextPages, elem, infScroll;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                (0, _createNewsWithinAdv2.default)(opt, undefined, 1);

                                _context.next = 3;
                                return (0, _getNextPages2.default)(opt);

                            case 3:
                                nextPages = _context.sent;
                                elem = document.querySelector('.next-article-place');
                                infScroll = new _infiniteScroll2.default(elem, {
                                    path: function path() {
                                        return nextPages[this.loadCount];
                                    },
                                    append: '.next-article',
                                    history: 'push',
                                    historyTitle: true,
                                    status: '.page-load-status',
                                    onInit: (0, _renderPreloader2.default)('.next-article-place'),
                                    scrollThreshold: 1000,
                                    prefill: true
                                });


                                if (!opt.specialProject || opt.subsiteName === 'education' || opt.subsiteName === 'games') {
                                    (0, _createAdvBetweenNewses2.default)(1);
                                }

                                if (opt.subsiteName === 'finance') {
                                    (0, _renderFinanceCatfish2.default)();
                                    (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);
                                }

                                (0, _sendToPiwik2.default)("scroll depth: 1");
                                (0, _createEventListeners2.default)(infScroll, opt);

                                if (window.innerWidth >= 1024 && !opt.withoutAds && opt.subsiteName === '24') {
                                    (0, _createCatfish2.default)(opt);
                                }

                                (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function initInfiniteScroll() {
                return _ref2.apply(this, arguments);
            };
        }();

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        (0, _initOnScroll2.default)({
                            timeout: 0,
                            scrollDepth: 10,
                            func: initInfiniteScroll
                        });

                        (0, _reloadOntheio2.default)(opt.newsTitle, window.location.href, true);
                        (0, _initViewCountForFirstNews2.default)(viewCounterObj[opt.newsId], opt.viewCountServiceDns);

                    case 3:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function (_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(71);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(102);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(154);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(opt) {
        var url, response, respJson, newsList, responseMap, respMap, positionsPinned, positions;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        url = void 0;

                        if (opt.byTheme) {
                            url = opt.baseServerPath + 'api/getScrollNewsLinksMapByTheme.do' + '?newsId=' + opt.newsId + '&lang=' + opt.lang + '&siteName=' + opt.subsiteName;
                        } else {
                            url = opt.baseServerPath + 'api/getScrollNewsLinksMap.do' + '?siteName=' + opt.subsiteName + '&lang=' + opt.lang;
                        }

                        _context.next = 4;
                        return fetch(url);

                    case 4:
                        response = _context.sent;
                        _context.next = 7;
                        return response.json();

                    case 7:
                        respJson = _context.sent;

                        delete respJson[opt.newsId];

                        newsList = (0, _values2.default)(respJson);

                        newsList.sort(function () {
                            return Math.round(Math.random()) - 0.5;
                        });

                        _context.next = 13;
                        return fetch(opt.baseServerPath + 'api/getPinnedScrollNewsLinksMap.do' + '?siteName=' + opt.subsiteName + '&lang=' + opt.lang);

                    case 13:
                        responseMap = _context.sent;
                        _context.next = 16;
                        return responseMap.json();

                    case 16:
                        respMap = _context.sent;

                        if ((0, _keys2.default)(respMap).length) {
                            positionsPinned = (0, _keys2.default)(respMap);

                            positionsPinned.forEach(function (p) {
                                var linkToNews = respMap[p];
                                linkToNews.forEach(function (url) {
                                    if (url.toString().includes(opt.newsId.toString())) {
                                        linkToNews.splice(linkToNews.indexOf(url), 1);
                                    } else {
                                        if (newsList.includes(url)) {
                                            newsList.splice(newsList.indexOf(url), 1);
                                        }
                                    }
                                });
                            });

                            positions = (0, _keys2.default)(respMap);

                            positions.forEach(function (e) {
                                if (newsList[e - 2] != null) {
                                    var randomNewsPinned = respMap[e][Math.floor(Math.random() * respMap[e].length)];
                                    if (randomNewsPinned) {
                                        newsList[e - 2] = randomNewsPinned;
                                    }
                                }
                            });
                        }

                        return _context.abrupt('return', newsList.slice(0, 10));

                    case 19:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function (_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(155), __esModule: true };

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(156);
module.exports = __webpack_require__(0).Object.values;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(105)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (infScroll, opt) {

    infScroll.on('request', function () {
        if (infScroll.loadCount > 0) {
            (0, _renderPreloader2.default)('.next-article');
        }

        if (opt.isMarketplace && infScroll.pageIndex === 1) {
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyMobileBranding2.default);
        }
    });

    infScroll.on('load', function () {
        document.getElementById('infinit-scroll-preloader').remove();

        (0, _sendToPiwik2.default)("scroll depth: " + (infScroll.loadCount + 1));

        if (!opt.isMarketplace) {
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyMobileBranding2.default);
        }
    });

    infScroll.on('append', function (response, path) {
        var event = new Event("infiniteNewsListAppended", { bubbles: true });
        document.dispatchEvent(event);

        var lastLoadedNews = (0, _getLastNews2.default)();
        lastLoadedNews.setAttribute('id', 'id' + path);
        lastLoadedNews.querySelector('h1').setAttribute('path', path);

        if (window.innerWidth > 640 && infScroll.pageIndex >= 2 && opt.withoutAds) {
            (0, _stylizeLikeWithoutAdvNews2.default)((0, _parseNewsId2.default)(path));
        }

        var socialSharingWrapper = lastLoadedNews.querySelector('.social-share-line-widget');
        if (socialSharingWrapper !== null) {
            socialSharingWrapper.setAttribute('path', 'sharing' + path);
        }

        try {
            if (window.instgrm) window.instgrm.Embeds.process();
        } catch (e) {}

        (0, _excludeContent2.default)('.recomendation_list', 0);

        if (opt.subsiteName === 'poker') {
            (0, _excludeContent2.default)('.mobileBrandingPlace', 0);
        }

        if (!opt.isMarketplace) {
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyMobileBranding2.default);
        }
    });

    var firstTitle = document.querySelector('h1');
    firstTitle.setAttribute('path', window.location.href);

    infScroll.on('history', function (title, path) {
        dataLayer.push({ 'event': 'InfiniteScrollHistoryChange' });
        (0, _reloadOntheio2.default)(title, path, false);
        (0, _reloadEndpoints2.default)(title, path, opt);

        if (opt.subsiteName === 'finance') {
            (0, _renderFinanceCatfish2.default)();
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);
        }

        if (infScroll.pageIndex > 2 && !(opt.withoutAds || opt.isMarketplace)) {
            (0, _createCatfish2.default)(opt);
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);
        }

        if (window.innerWidth > 1024 && infScroll.pageIndex === 2 && !(opt.isMarketplace || opt.withoutAds)) {
            (0, _createCatfish2.default)(opt);
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);
        } else if (window.innerWidth < 640 && (infScroll.scrollPageIndex === 1 || opt.subsiteName === 'sport') && !opt.withoutAds && opt.showMobileBrandingOnSecondNews && opt.subsiteName !== 'poker') {
            (0, _createMobileBranding2.default)(opt, (0, _parseNewsId2.default)(path));
            (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyMobileBranding2.default);
        } else if (window.innerWidth < 640 && !opt.showMobileBrandingOnSecondNews) {
            hideMobileBrandingPlace(path);
            (0, _destroyMobileBranding2.default)();
            if (!opt.isMarketplace) {
                (0, _createCatfish2.default)(opt);
                (0, _createIntersectionObserver2.default)('.adv-destroy', _destroyCatfish2.default);
            }
        } else {
            hideMobileBrandingPlace(path);
        }

        if (window.innerWidth >= 1300) {
            (0, _createDesktopBranding2.default)(opt, (0, _parseNewsId2.default)(path));
        }

        if (!opt.specialProject || opt.subsiteName === 'education' || opt.subsiteName === 'games') {
            (0, _createAdvBetweenNewses2.default)(infScroll.scrollPageIndex + 1);
        }

        (0, _createNewsWithinAdv2.default)(opt, path, infScroll.scrollPageIndex + 1);
    });

    infScroll.on('error', function () {
        document.getElementById('infinit-scroll-preloader').remove();
    });

    infScroll.on('last', function () {});

    function hideMobileBrandingPlace(path) {
        var mobileBrandingPlace = document.getElementById('mobileBrandingPlace' + (0, _parseNewsId2.default)(path));
        if (mobileBrandingPlace !== null) {
            mobileBrandingPlace.style.display = 'none';
        }
    }
};

var _renderPreloader = __webpack_require__(125);

var _renderPreloader2 = _interopRequireDefault(_renderPreloader);

var _reloadEndpoints = __webpack_require__(158);

var _reloadEndpoints2 = _interopRequireDefault(_reloadEndpoints);

var _reloadOntheio = __webpack_require__(129);

var _reloadOntheio2 = _interopRequireDefault(_reloadOntheio);

var _sendToPiwik = __webpack_require__(31);

var _sendToPiwik2 = _interopRequireDefault(_sendToPiwik);

var _createIntersectionObserver = __webpack_require__(76);

var _createIntersectionObserver2 = _interopRequireDefault(_createIntersectionObserver);

var _createCatfish = __webpack_require__(90);

var _createCatfish2 = _interopRequireDefault(_createCatfish);

var _createNewsWithinAdv = __webpack_require__(134);

var _createNewsWithinAdv2 = _interopRequireDefault(_createNewsWithinAdv);

var _createAdvBetweenNewses = __webpack_require__(135);

var _createAdvBetweenNewses2 = _interopRequireDefault(_createAdvBetweenNewses);

var _createMobileBranding = __webpack_require__(136);

var _createMobileBranding2 = _interopRequireDefault(_createMobileBranding);

var _createDesktopBranding = __webpack_require__(137);

var _createDesktopBranding2 = _interopRequireDefault(_createDesktopBranding);

var _destroyCatfish = __webpack_require__(77);

var _destroyCatfish2 = _interopRequireDefault(_destroyCatfish);

var _destroyMobileBranding = __webpack_require__(104);

var _destroyMobileBranding2 = _interopRequireDefault(_destroyMobileBranding);

var _getLastNews = __webpack_require__(126);

var _getLastNews2 = _interopRequireDefault(_getLastNews);

var _excludeContent = __webpack_require__(167);

var _excludeContent2 = _interopRequireDefault(_excludeContent);

var _parseNewsId = __webpack_require__(128);

var _parseNewsId2 = _interopRequireDefault(_parseNewsId);

var _stylizeLikeWithoutAdvNews = __webpack_require__(168);

var _stylizeLikeWithoutAdvNews2 = _interopRequireDefault(_stylizeLikeWithoutAdvNews);

var _renderFinanceCatfish = __webpack_require__(138);

var _renderFinanceCatfish2 = _interopRequireDefault(_renderFinanceCatfish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (title, path, opt) {
    new _inlineGallery2.default({
        dns: opt.dns,
        appVersion: opt.appVersion
    });

    new _linksTooltip2.default();

    new _electionWidget2.default();

    new _readMoreStyler2.default();

    var newsId = (0, _parseNewsId2.default)(path);
    new _mainGallery2.default({
        dns: opt.dns,
        appVersion: opt.appVersion,
        newsId: newsId
    });

    new _photoComparator2.default();

    new _bottomTagsShowMore2.default();

    new _viewCount2.default({
        selector: '#views-counter-' + viewCounterObj[newsId],
        entityKey: viewCounterObj[newsId],
        apiDns: opt.viewCountServiceDns
    });
};

var _photoComparator = __webpack_require__(112);

var _photoComparator2 = _interopRequireDefault(_photoComparator);

var _inlineGallery = __webpack_require__(111);

var _inlineGallery2 = _interopRequireDefault(_inlineGallery);

var _linksTooltip = __webpack_require__(113);

var _linksTooltip2 = _interopRequireDefault(_linksTooltip);

var _readMoreStyler = __webpack_require__(114);

var _readMoreStyler2 = _interopRequireDefault(_readMoreStyler);

var _mainGallery = __webpack_require__(139);

var _mainGallery2 = _interopRequireDefault(_mainGallery);

var _bottomTagsShowMore = __webpack_require__(127);

var _bottomTagsShowMore2 = _interopRequireDefault(_bottomTagsShowMore);

var _viewCount = __webpack_require__(101);

var _viewCount2 = _interopRequireDefault(_viewCount);

var _parseNewsId = __webpack_require__(128);

var _parseNewsId2 = _interopRequireDefault(_parseNewsId);

var _electionWidget = __webpack_require__(159);

var _electionWidget2 = _interopRequireDefault(_electionWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(102);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function () {
    var electionWidgetPlace = document.getElementById('result-city-list');

    if (electionWidgetPlace === null || electionWidgetPlace.classList.contains('inited')) {
        return;
    }

    var opt = {};

    if (!window.location.pathname.includes('/ru/')) {
        opt.cityMayor = 'МЕР МІСТА';
        opt.regionConsignment = 'ПАРТІЯ (ОБЛАСТЬ)';
        opt.cityConsignment = 'ПАРТІЯ (МІСТО)';
        opt.moreDetails = 'детальніше';
        opt.hide = 'приховати';
    } else {
        opt.cityMayor = 'МЭР ГОРОДА';
        opt.regionConsignment = 'ПАРТИЯ (ОБЛАСТЬ)';
        opt.cityConsignment = 'ПАРТИЯ (ГОРОД)';
        opt.moreDetails = 'детальнее';
        opt.hide = 'спрятать';
    }

    var urlToTable = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTUYq1JJLwus1D97NQd_b8ul-B9lVhccjQONO3qF0xQr-KFzG_MaXxN7KkThaBHIpVbLcpY1xP4FH6r/pubhtml#';

    var allCitiesData = (0, _googleTableParser2.default)(urlToTable);
    var cities = (0, _keys2.default)(allCitiesData);

    for (var i = 0; i < cities.length; i++) {
        renderTable(i, allCitiesData[cities[i]], cities[i]);
    }

    function renderTable(index, allCitiesData, city) {
        renderCity(city, index);
        renderCandidates(index, allCitiesData);
        renderShowMore(index);
        addListeners(index);
    }

    function renderCity(city, index) {
        var cityWrapper = document.createElement('div');
        cityWrapper.classList.add('city-item');

        cityWrapper.innerHTML = '<div class="city-name">\n' + '' + city + '\n' + '</div>';

        cityWrapper.innerHTML += '<div class="results" id="results-' + index + '">\n' + '' + '</div>';

        document.getElementById('result-city-list').appendChild(cityWrapper);
    }

    function renderCandidates(index, allCitiesData) {
        var leader = allCitiesData[0][0];
        var leaderIndex = 0;

        for (var _i = 0; _i < 3; _i++) {
            if (parseInt(leader[1], 10) < parseInt(allCitiesData[_i][0][1], 10)) {
                leader = allCitiesData[_i][0];
                leaderIndex = _i;
            }
        }

        for (var j = 0; j < 3; j++) {
            var candidateType = void 0;
            var candidateClass = void 0;

            if (j === 0) {
                candidateClass = 'city-mayor';
                candidateType = opt.cityMayor + ':';
            } else if (j === 1) {
                candidateClass = 'region-party';
                candidateType = opt.regionConsignment + ':';
            } else {
                candidateClass = 'city-party';
                candidateType = opt.cityConsignment + ':';
            }

            var resultsWrapper = document.createElement('div');
            resultsWrapper.classList.add(candidateClass);
            resultsWrapper.classList.add('result-type');
            resultsWrapper.id = candidateClass + '-' + index;
            resultsWrapper.innerHTML = '<p>' + candidateType + '</p>';

            document.getElementById('results-' + index).appendChild(resultsWrapper);
            for (var _i2 = 0; _i2 < allCitiesData[0].length; _i2++) {
                var candidate = document.createElement('div');
                var candidatePosition = document.createElement('div');
                var candidateStatistics = document.createElement('div');
                var candidateInterest = document.createElement('div');
                var candidateName = document.createElement('div');
                var votesNumber = document.createElement('div');
                var votesWrapper = document.createElement('div');

                candidateName.classList.add('candidate-name');
                candidateName.innerText = allCitiesData[j][_i2][0];

                votesWrapper.classList.add('votes-number');
                if (leaderIndex === j && _i2 === 0) {
                    votesWrapper.classList.add('winner');
                } else if (_i2 !== 0) {
                    votesWrapper.classList.add('looser');
                }
                votesWrapper.style.width = allCitiesData[j][_i2][1] + '%';

                votesNumber.classList.add('statistic');
                votesNumber.appendChild(votesWrapper);

                candidate.classList.add('candidate-item');

                candidatePosition.classList.add('position');
                candidatePosition.innerText = _i2 + 1;

                candidateStatistics.classList.add('candidate-statistic');
                candidateStatistics.appendChild(candidateName);
                candidateStatistics.appendChild(votesNumber);

                candidateInterest.classList.add('candidate-interest');
                candidateInterest.innerText = allCitiesData[j][_i2][1] + '%';

                candidate.appendChild(candidatePosition);
                candidate.appendChild(candidateStatistics);
                candidate.appendChild(candidateInterest);

                document.getElementById(candidateClass + '-' + index).appendChild(candidate);
            }
        }
    }

    function renderShowMore(index) {
        var showMoreWrapper = document.createElement('div');
        showMoreWrapper.classList.add('show-all');
        showMoreWrapper.innerHTML = '    ' + opt.moreDetails + '\n' + '    <span>' + opt.hide + '</span>\n' + '    <span class="image"></span>';

        document.getElementById('results-' + index).appendChild(showMoreWrapper);
    }

    function addListeners(index) {
        var showMoreButton = $('#results-' + index + ' > div.show-all');
        showMoreButton.on('click', function () {
            $('#results-' + index).children('.result-type').toggleClass('active');
            $('#results-' + index + ' > div.show-all').toggleClass('active');
        });

        electionWidgetPlace.classList.add('inited');
    }
};

var _googleTableParser = __webpack_require__(160);

var _googleTableParser2 = _interopRequireDefault(_googleTableParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

exports.default = function (urlToTable) {
    var request = new XMLHttpRequest();
    var parsedTables = {};

    request.onload = getData;
    request.open("GET", urlToTable, false);
    request.send();

    function getData() {
        var parser = new DOMParser();
        var doc = parser.parseFromString(request.responseText, "text/html");

        parsedTables = parseTables(doc);
    }

    function parseTables(doc) {
        var tables = (0, _from2.default)(doc.getElementById('sheets-viewport').querySelectorAll('div > table > tbody'));
        var cities = getCities(doc);
        var allCitiesData = {};

        for (var i = 0; i < tables.length; i++) {
            var singleCityCandidates = [];

            (0, _from2.default)(tables[i].querySelectorAll('tr > th')).forEach(function (element) {
                return element.remove();
            });

            singleCityCandidates = getCityCandidatesFromTable(tables[i]);
            sortTable(singleCityCandidates);

            allCitiesData[cities[i]] = singleCityCandidates;
        }

        return allCitiesData;
    }

    function getCities(doc) {
        var elements = doc.querySelectorAll('#sheet-menu > li > a');
        var cities = [];

        for (var i = 0; i < elements.length; i++) {
            cities[i] = elements.item(i).innerText;
        }

        return cities;
    }

    function getCityCandidatesFromTable(table) {
        var mayors = [],
            regionConsignment = [],
            cityConsignment = [],
            cityCandidates = [];
        for (var i = 1; i < table.childElementCount; i++) {
            var mayorCandidate = [];
            var regionConsignmentCandidate = [];
            var cityConsignmentCandidate = [];
            for (var j = 0; j < 6; j++) {
                var candidateField = table.getElementsByTagName('tr')[i].getElementsByTagName('td').item(j);

                if (candidateField === null) {
                    return;
                }

                if (j < 2) {
                    mayorCandidate.push(candidateField.innerText);
                } else if (j < 4) {
                    regionConsignmentCandidate.push(candidateField.innerText);
                } else {
                    cityConsignmentCandidate.push(candidateField.innerText);

                    if (j === 5) {
                        mayors.push(mayorCandidate);
                        regionConsignment.push(regionConsignmentCandidate);
                        cityConsignment.push(cityConsignmentCandidate);
                    }
                }
            }
            if (i === table.childElementCount - 1) {
                cityCandidates[0] = mayors;
                cityCandidates[1] = regionConsignment;
                cityCandidates[2] = cityConsignment;
            }
        }

        return cityCandidates;
    }

    function sortTable(table) {
        for (var i = 0; i < table.length; i++) {
            var city = table[i];

            for (var j = 0; j < city.length - 1; j++) {
                for (var k = 0; k < city.length - j - 1; k++) {
                    if (parseInt(city[k][1], 10) < parseInt(city[k + 1][1], 10)) {
                        var tmp = city[k];
                        city[k] = city[k + 1];
                        city[k + 1] = tmp;
                    }
                }
            }
        }
    }

    return parsedTables;
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId, elemCount, newsIndex, opt) {
    var wrapperId = 'adv' + newsId + elemCount;
    var advWrapper = document.getElementById(wrapperId);

    if (opt.isMarketplace && (opt.subsiteName === 'education' || opt.subsiteName === 'sport') && newsIndex === 1) {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        if (newsIndex === 1 && window.innerWidth >= 1024) {
            (0, _sendToPiwik2.default)('render first adv within news (Adpartner)', 'call');

            document.getElementById(wrapperId).innerHTML = '<div id="adpartner-vunit-' + contentRollAdPartnerId + '"></div>\n' + '    <div id="adpartner-htmlunit-750"></div>';

            (0, _loadScript2.default)("https://a4p.adpartner.pro/vunit?id=" + contentRollAdPartnerId + "&" + Math.random());
            (0, _loadScript2.default)("https://a4p.adpartner.pro/htmlunit?id=750&" + Math.random());

            var trackShowingAdpartner = function trackShowingAdpartner() {
                (0, _sendToPiwik2.default)('render first adv within news (Adpartner)', 'show');
            };
            (0, _advDelayLoad2.default)(trackShowingAdpartner, wrapperId, '0px');
        } else if (newsIndex >= 2 && newsIndex <= 5) {
            if (window.innerWidth < 640) {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_1_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px');
            } else {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_desktop_1_(2-5)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        } else {
            if (advWrapper.offsetWidth < 610 && newsIndex >= 6) {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_first', [300, 250], wrapperId, '300px');
            } else if (advWrapper.offsetWidth < 610) {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_1_1', [300, 250], wrapperId, '300px');
            } else {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_desktop_1_(6-11)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        }
    }
};

var _sendToPiwik = __webpack_require__(31);

var _sendToPiwik2 = _interopRequireDefault(_sendToPiwik);

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

var _advDelayLoad = __webpack_require__(94);

var _advDelayLoad2 = _interopRequireDefault(_advDelayLoad);

var _loadScript = __webpack_require__(53);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId, elemCount, newsIndex, opt) {
    var wrapperId = 'adv' + newsId + elemCount;
    var advWrapper = document.getElementById(wrapperId);

    if (opt.isMarketplace && opt.subsiteName === 'education') {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        if (window.innerWidth < 640) {
            (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_second', [300, 250], wrapperId);
        } else {
            (0, _getDFPBlock2.default)('/56301415/24tv_in_news_desktop_second', [580, 400], wrapperId, '580px');
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId, elemCount, newsIndex, opt) {
    var wrapperId = 'adv' + newsId + elemCount;
    var advWrapper = document.getElementById(wrapperId);

    if (opt.isMarketplace && opt.subsiteName === 'education') {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        var promoblockWrapper = document.getElementById('div-gpt-ad-1438691081622-0');
        if (promoblockWrapper !== null && promoblockWrapper.childNodes.length === 0 && window.innerWidth <= 640) {
            (0, _getDFPBlock2.default)('/56301415/24tv_promoArticle', [1, 1], 'div-gpt-ad-1438691081622-0', '300px', function () {
                var promoBlock = document.getElementById("newsListPromoArticle");
                document.getElementById(wrapperId).appendChild(promoBlock);
            }, {
                id: '/56301415/24tv_in_news_mobile_third',
                size: [300, 250],
                wrapper: wrapperId
            });
        } else if (window.innerWidth <= 640) {
            (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_third', [300, 250], wrapperId);
        }

        if (window.innerWidth > 640) {
            (0, _getDFPBlock2.default)('/56301415/24tv_in_news_desktop_third', [580, 400], wrapperId, '580px');
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId, newsIndex) {
    var wrapperId = 'adv' + newsId + 100;
    var advWrapper = document.getElementById(wrapperId);

    var advSecond = document.getElementById('adv' + newsId + 200);
    var advThird = document.getElementById('adv' + newsId + 300);

    if (advSecond !== null) {
        advSecond.remove();
    }

    if (advThird !== null) {
        advThird.remove();
    }

    if (newsIndex === 1) {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if (advWrapper !== null && advWrapper.childNodes.length === 0) {
        if (newsIndex >= 2) {
            if (window.innerWidth < 640) {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_mobile_1_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px');
            } else {
                (0, _getDFPBlock2.default)('/56301415/24tv_in_news_desktop_1_(2-5)', [[1, 1], [580, 400]], wrapperId, '580px');
            }
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsIndex) {
    if (newsIndex === 1) {
        var readMoreWidget = document.getElementsByClassName('read-also')[0];
        if (readMoreWidget !== null && typeof readMoreWidget !== "undefined") {
            var advPlace = document.createElement('div');
            advPlace.style.minHeight = '100px';
            advPlace.id = 'maraton-in-news';

            if (document.getElementById(advPlace.id) !== null) {
                return;
            }

            readMoreWidget.after(advPlace);

            (0, _getDFPBlock2.default)('/56301415/24tv_sport_800x70_desktop', [1, 1], advPlace.id);
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId) {
    var summary = document.querySelector('#newsBodyWrap-' + newsId + ' > .article_text > #newsSummary');
    if (summary !== null) {
        var newsMiddleNode = summary.childNodes[Math.floor(summary.childNodes.length / 2) + 1];
        var advPlace = document.createElement('div');
        advPlace.id = 'adv' + newsId;
        advPlace.style.minHeight = '300px';

        if (document.getElementById(advPlace.id) !== null) {
            return;
        }

        newsMiddleNode.after(advPlace);

        if (window.innerWidth < 640) {
            (0, _getDFPBlock2.default)('/56301415/24tv_fun_300x250_mobile', [300, 250], advPlace.id, '300px');
        } else {
            (0, _getDFPBlock2.default)('/56301415/24tv_fun_600x300_desktop', [600, 300], advPlace.id, '600px');
        }
    }
};

var _getDFPBlock = __webpack_require__(25);

var _getDFPBlock2 = _interopRequireDefault(_getDFPBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (selector, leave) {
    var elements = document.querySelectorAll(selector);

    elements.forEach(function (item, index) {
        if (index !== leave) {
            item.remove();
        }
    });
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stylizeLikeWithoutAdvNews;
function stylizeLikeWithoutAdvNews(newsId) {
    var bodyWrapper = document.getElementById('newsBodyWrap-' + newsId);
    if (bodyWrapper != null && !bodyWrapper.classList.contains('news-body-wrap')) {
        bodyWrapper.classList.add('news-body-wrap');
    }
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (newsId, serviceDns) {
    new _viewCount2.default({
        selector: '#views-counter-' + newsId,
        entityKey: newsId,
        apiDns: serviceDns
    });
};

var _viewCount = __webpack_require__(101);

var _viewCount2 = _interopRequireDefault(_viewCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    if (document.querySelectorAll(".responsive-embed-football-table iframe[data-src]").length > 0) {
        if (window.addEventListener) {
            window.addEventListener("message", function (event) {
                resizeFootballEmbedTable(event.data);
            });
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", function (event) {
                resizeFootballEmbedTable(event.data);
            });
        }
    }

    function resizeFootballEmbedTable(data) {
        if (data.message === "footballEmbedTable") {
            var tableIframe = document.querySelector("iframe[data-src='" + data.url + "']");
            if (tableIframe !== null) {
                tableIframe.setAttribute("height", data.height + 50);
            }
        }
    }
};

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _inlineGallery = __webpack_require__(111);

var _inlineGallery2 = _interopRequireDefault(_inlineGallery);

var _mainGallery = __webpack_require__(139);

var _mainGallery2 = _interopRequireDefault(_mainGallery);

var _photoComparator = __webpack_require__(112);

var _photoComparator2 = _interopRequireDefault(_photoComparator);

var _viewCount = __webpack_require__(101);

var _viewCount2 = _interopRequireDefault(_viewCount);

var _index = __webpack_require__(113);

var _index2 = _interopRequireDefault(_index);

var _readMoreStyler = __webpack_require__(114);

var _readMoreStyler2 = _interopRequireDefault(_readMoreStyler);

var _initInfiniteScroll = __webpack_require__(152);

var _initInfiniteScroll2 = _interopRequireDefault(_initInfiniteScroll);

var _bottomTagsShowMore = __webpack_require__(127);

var _bottomTagsShowMore2 = _interopRequireDefault(_bottomTagsShowMore);

var _resizeFootballTables = __webpack_require__(170);

var _resizeFootballTables2 = _interopRequireDefault(_resizeFootballTables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.inlineGallery = _inlineGallery2.default;
exports.linksTooltip = _index2.default;
exports.viewCount = _viewCount2.default;
exports.readMoreStyler = _readMoreStyler2.default;
exports.initInfiniteScroll = _initInfiniteScroll2.default;
exports.mainGallery = _mainGallery2.default;
exports.bottomTagsShowMore = _bottomTagsShowMore2.default;
exports.photoComparator = _photoComparator2.default;

new _resizeFootballTables2.default();

/***/ })
/******/ ]);
});